import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate';
// import AllocationTableTemplate from '../../common/AllocationTable';
import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    getPendingforallocationList as pendingshipmentList,
    AllocatedShipmentDetails as AllocatedFwdShipmentDetails,
    ClientNameList as ClientNameList,
    validateEODAllocation as EODValidation,
    TriDetails as GetTripdetails,
    AllocateShipment as AllocateShipment,
    PreviousDayShipment as PreviousDayShipmentDetails,
    GetHubFlags1 as GetHubFlags2,
    CloseTrip1 as CloseTrip,
    PendingList as PendingList2,
    ServiceType as ServiceType1,
    VehicleList1 as VehicleList,
    CreateTrip as CreateTrip,
    GetSubcluster as SameRouteShipments,
    GetEscalation1 as GetEscalation,
    ShipmentConfirm as ConfirmShipment,
    ShipmentPrintDetails1 as ShipmentPrintDetails,
    pdfData1 as pdfData,
    getUnallocatedShipmentsByShipmentType as getUnallocatedShipments,
    getSameCustomerShipments as getSameCustomerShipmentsforRVP,
    RemoveAllocatedShipment1 as RemoveAllocatedShipment,
    GetShipmentCount1 as GetShipmentCount,
    SubmitReason1 as StoreReason,
    SeqofNonAllocation as GetNonAllocationSEQ,
    GetBikeVehicleList as BikeVehicleList,
    GetShipmentTableDetails as GetShipmentTableDetails,
    GetRvpDashboardCounts as GetRvpDashboardCounts,
    ScanTallyBatchStatus as ScanTallyBatchStatus,
    getUserCodDetails as getUserCodDetails,
    fetchAdhocVehicleList as AdhocVehicleList,
} from '../../../../../services/modules/newallocationservices.js';
import { EventBus } from '../../../../main.js';


import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments,
        // 'load-allocation-table-template': AllocationTableTemplate
    },
    mixins: [PageTracker],
    props: {
        srList: Array,
        hyperVMsgData: Object,
        hubCODPendingLimit: { type: [String, Number]},
        IsPendingCODBlock: { type: [String, Boolean]},
        isRSVSr: { type: [String, Number]},
        ServiceTypeArrayList: Array,
        ServiceTypeList: Array,
        EscalationList: Array,
        ClusterList: Array,
        allocationrefreshflag: { type: [String, Number]},
        isSVCEnabledForAdhocVehicles: { type: [String, Boolean]}
    },
    data: function() {
        return {
            userHubIdArr: [],
            value: false,
            PDDPopup: false,
            vehiclePopup: false,
            currentScreenTab: 'ALL',
            CourierCompanyID: '',
            IsSRNeedTrip: false,
            // isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            EmpType: '',
            SRSelectingloader: false,
            srArrayList: [],
            // srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            clientList: [],
            clientArrayList: [],
            Clientname: '',
            ClientObj: {
                value: "",
                text: ""
            },
            Clientname2: '',
            ClientObj2: {
                value: "",
                text: ""
            },
            ClientLoader: '',
            ServiceType: '',
            // ServiceTypeArrayList: [],
            // ServiceTypeList: [],
            ServiceTypeObj: {
                value: "",
                text: ""
            },
            ServiceLoader: false,
            WeightGroup: '',
            WeightGList: [{
                    value: "0,1",
                    text: "All"
                },
                {
                    value: "1",
                    text: "Heavies"
                },
                {
                    value: "0",
                    text: "Regular"
                },
            ],
            WeightGObj: {},
            EscalationLoader: '',
            Escalation: '',
            // EscalationList: [],
            // EscalationListArrayList: [],
            EscalationObj: {
                value: "",
                text: ""
            },
            ClusterLoader: '',
            ClusterId: '',
            // ClusterList: [],
            // ClusterArrayList: [],
            ClusterObj: {
                value: "",
                text: ""
            },
            shipmentNo: '',
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],

            AllocatedList: [],
            AllocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "EDD Date",
                    key: "EDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Shipment Type",
                    key: "ServiceType",
                },
                {
                    label: "Pincode",
                    key: "ShipPincode",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SuggestionList: [],
            SuggestionColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "PDD date",
                    key: "PDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NPR Reason",
                    key: "NDRReason",
                },
                {
                    label: "EDD date",
                    key: "EDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteList: [],
            startAllocationFlag: false,
            AllocateLoading: false,
            isAllocation: false,
            isConfirmLoad: false,
            dismissSecs: 20,
            dismissCountDown: 0,
            allocationErrorMsg: "",
            dismissCountDownSuccess: 0,
            allocationSuccessMsg: "",
            flagShowPreviousShipment: false,
            showShipmentModel: false,
            isPodsLoader: false,
            PendingList: [],
            showGroupIdShipmentModel: false,
            showParentGroupIdShipmentList: [],
            pendingGrouptErrorMsg: '',
            IsLongPinCodeFlag: null,
            ebnVehicleNo: '',
            errEbnVehicleNo: '',
            flagShowEbnVehicleNo: false,
            closeTripModel: false,
            startTripFlag: false,
            tripId: '',
            openKmImg: '',
            openKm: '',
            closeKmImg: '',
            closeKm: '',
            errorOpenKM: '',
            errorCloseKM: '',
            originCloseImg: '',
            srVehicleNo: '',
            tripTitle: 'Start Trip',
            tripCreatedDate: '',
            currentDateTime: '',
            tripDayflag: 0,
            tripDateFlag: false,
            vehicleTypeFlag: false,
            vehicleNo: '',
            vehicleOpenKM: '',
            errVehicleNo: '',
            vehicleTypeFlag: false,
            vehicleType: '',
            srVehicleList: [],
            vehicleNoItemObj: {
                value: '',
                text: ''
            },
            errVehicleKm: '',
            isVehicleReplacedCheck: 0,
            isVehicleReplaced: false,
            vehicleVendorId: '',
            allocationLoader: false,
            PrintShipmentModal: false,
            batchCreatedDate: '',
            PrintShipmentsList: [],
            PrintShipmentsColumns: [{
                    label: "Delivery User",
                    key: "SrName",
                },
                {
                    label: "Created Date",
                    key: "CreatedDate",
                },
            ],
            ShowPrintTable: false,
            isLoadPDF: false,
            isLoadBatch: false,
            shippingIDArray: [],
            ResCreatedDate: '',
            EnableHyperLink: false,
            unallocatePageNumber: 1,
            unallocatePageLimit: 10,
            unallocateTotalCount: 0,
            unallocatepageCount: 1,
            AccAWBNumbers: '',
            srallocatePageNumber: 1,
            srAllocatedTotalCount: 0,
            srAllocatedPageCount: 1,
            srAllocatedPageLimit: 10,
            huballocatePageNumber: 1,
            hubAllocatedTotalCount: 0,
            hubAllocatedPageCount: 0,
            hubAllocatedPageLimit: 10,
            IsAllData: true,
            Tobeattempted: false,
            Pddbreached: false,
            Pddbreachedinnext24hours: false,
            FakeAttempt: false,
            disableprint: false,
            PDLoading: false,
            SMLoading: false,
            UNLoading: false,
            UASelectedArr: [],
            PDSelectedArr: [],
            SMSelectedArr: [],
            AllCount: 0,
            pddBreachedCount: 0,
            PDDBreachedinNext24hrsCount: 0,
            fakeAttemptsCount: 0,
            tobeAttemptedTodayCount: 0,
            CountLoading: false,
            errorRvpAllocation: '',
            successRvpAllocation: '',
            suggestRVPArrayList: '',
            morePendingRVPShipmentsModel: false,
            IsrvpMPSAllocation: false,
            sAllMoreShip: '',
            selectedPickupsMore: '',
            isLoadingASL: false,
            sameCustomerTitle: 'Shipments belongs to same customer',
            rvpAddress: '',
            holdTempMPSData: [],
            IsrvpMPSAllocation: false,
            mpsErrorLabel: 'Below highlighted shipments are from same mps group , Please allocate them to same SR.',
            hideAllocateFlag: true,
            isLoadingRvpPickup: true,
            resArray: [],
            showParentGroupIdShipmentListLoader: false,
            IsRVPPaperless: false,
            TopReset: true,
            AllocateTableLoader: false,
            PDTableLoader: false,
            SMTableLoader: false,
            UATableLoader: false,
            HUbAllocatedTableLoader: false,
            continueloader: false,
            PassEOD: false,
            shippingData: [],
            VehicalNo: 0,
            EBNshippingData: [],
            vehicleNumbers: {},
            storeAns: [],
            NonAllocationRsn: false,
            Reason: '',
            ReasonList: [],
            ReasonObj: {
                text: ""
            },
            BucketName: '',
            selectedItems: [],
            TitleName: '',
            IsReload: false,
            fromList: [{ value: "UA", text: "From Mobile" }, { value: "Web", text: "From Web" }],
            fromItemObj: { value: "UA", text: "From Mobile" },
            fromId: "UA",
            ebnDataLoader: false,
            vehicleNoRegExp: /^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$/,
            ResetLoader: false,
            resultCount: 0,
            SEQShippingids: [],
            rvpPrexoShipmentList: [],
            rvpPrexoShipMsg: 'This is a PREXO shipment, and its associated Delivery shipment is :- ',
            rvpPrexoShipMsgBulk: 'You have allocated some prexo shipments, find below associated Delivery shipments :- ',
            userDataKey: '',
            startTripModelFlag: false,
            // RVP New Allocation Param
            //New Allocation as per mobile
            isShowPendingAllocatedList: true, //Show the pending list
            // pendingSrShipmentCount: 0,
            // pendingSVCShipmentCount: 0,
            // allocateSrShipmentCount: 0,
            // allocateSVCShipmentCount: 0,

            setDashboardCountTabNameType: 'pending',
            setCountSR: 0,
            setCountSVC: 0,
            srBlockFlag: true,
            svcBlockFlag: false,

            // //Allocated
            // setCountSRAllocated: 0,
            // setCountSVCAllocated: 0,
            // srAllocatedBlockFlag: false,
            // svcAllocatedBlockFlag: false,
            // //Counts Pending Sr
            // setSRCountAll: 0,
            // setSRCountP0: 0,
            // setSRCountP1: 0,
            // setSRCountP2: 0,
            // setSRCountSame_route: 0,

            // //Counts Allocated Sr
            // setSRAllocatedCountAll: 0,
            // setSRAllocatedCountP0: 0,
            // setSRAllocatedCountP1: 0,
            // setSRAllocatedCountP2: 0,
            // setSRAllocatedCountSame_route: 0,
            // //Count Pending Hide Show flag for SR
            // setSRCountAllFlag: true,
            // setSRCountP0Flag: true,
            // setSRCountP1Flag: true,
            // setSRCountP2Flag: true,
            // setSRCountSame_routeFlag: true,
            // //Count Allocated Hide Show flag for SR
            // setSRAllocatedCountAllFlag: false,
            // setSRAllocatedCountP0Flag: false,
            // setSRAllocatedCountP1Flag: false,
            // setSRAllocatedCountP2Flag: false,
            // setSRAllocatedCountSame_routeFlag: false,
            // //List Pending Sr
            // setSRListAll: [],
            // setSRListP0: [],
            // setSRListP1: [],
            // setSRListP2: [],
            // setSRListSame_route: [],
            // //List Allocated Sr List
            // setSRAllocatedListAll: [],
            // setSRAllocatedListP0: [],
            // setSRAllocatedListP1: [],
            // setSRAllocatedListP2: [],
            // setSRAllocatedListSame_route: [],
            // //Count Pending SVC
            // setSVCCountAll: 0,
            // setSVCCountP0: 0,
            // setSVCCountP1: 0,
            // setSVCCountP2: 0,
            // setSVCCountSame_route: 0,

            // //Count Allocated SVC
            // setSVCAllocatedCountAll: 0,
            // setSVCAllocatedCountP0: 0,
            // setSVCAllocatedCountP1: 0,
            // setSVCAllocatedCountP2: 0,
            // setSVCAllocatedCountSame_route: 0,

            // //List Pending SVC
            // setSVCListAll: [],
            // setSVCListP0: [],
            // setSVCListP1: [],
            // setSVCListP2: [],
            // setSVCListSame_route: [],
            // //List Allocated SVC
            // setSVCAllocatedListAll: [],
            // setSVCAllocatedListP0: [],
            // setSVCAllocatedListP1: [],
            // setSVCAllocatedListP2: [],
            // setSVCAllocatedListSame_route: [],
            // //Count Pending Hide Show flag for SVC
            // setSVCCountAllFlag: false,
            // setSVCCountP0Flag: false,
            // setSVCCountP1Flag: false,
            // setSVCCountP2Flag: false,
            // setSVCCountSame_routeFlag: false,

            // //Count Allocated Hide Show flag for SVC
            // setSVCAllocatedCountAllFlag: false,
            // setSVCAllocatedCountP0Flag: false,
            // setSVCAllocatedCountP1Flag: false,
            // setSVCAllocatedCountP2Flag: false,
            // setSVCAllocatedCountSame_routeFlag: false,
            //active tab show flag for Pending
            activeTabSR: "light",
            activeTabSVC: 'outline-primary',
            //active tab show flag for Allocated
            activeTabSRAllocated: "light",
            activeTabSVCAllocated: 'outline-primary',

            // //highlight active button flag pending SR
            // activeTabSRAllFlag: 'outline-primary',
            // activeTabSRP0Flag: 'outline-primary',
            // activeTabSRP1Flag: 'outline-primary',
            // activeTabSRP2Flag: 'outline-primary',
            // activeTabSRSameRouteFlag: 'outline-primary',

            // //highlight active button flag pending SR
            // activeTabSRAllocatedAllFlag: 'outline-primary',
            // activeTabSRAllocatedP0Flag: 'outline-primary',
            // activeTabSRAllocatedP1Flag: 'outline-primary',
            // activeTabSRAllocatedP2Flag: 'outline-primary',
            // activeTabSRSameRouteFlag: 'outline-primary',


            // //highlight active button flag pending SVC
            // activeTabSVCAllFlag: 'outline-primary',
            // activeTabSVCP0Flag: 'outline-primary',
            // activeTabSVCP1Flag: 'outline-primary',
            // activeTabSVCP2Flag: 'outline-primary',
            // activeTabSVCSameRouteFlag: 'outline-primary',

            // //highlight active button flag Allocated SVC
            // activeTabSVCAllocatedAllFlag: 'outline-primary',
            // activeTabSVCAllocatedP0Flag: 'outline-primary',
            // activeTabSVCAllocatedP1Flag: 'outline-primary',
            // activeTabSVCAllocatedP2Flag: 'outline-primary',
            // activeTabSVCAllocatedSameRouteFlag: 'outline-primary',

            //Search Pending Shipment
            searchPendingShipment: '',
            PendingColumns: [
                { key: 'CustomerAddress', label: 'Pickup Address', type: 'text', size: 'min-width: 150px; white-space: normal; word-wrap: break-word;' },
                { key: 'ShipPincode', label: 'Pincode', type: 'text', size: 'min-width: 50px;' },
                { key: 'ClientName', label: 'Client Name', type: 'text', size: 'min-width: 100px;' },
                { key: ['ShippingID', 'MultiShipmentGroupID', 'NoOfMultiShipmentGroupId'], label: 'AWB|MPS', type: 'text', size: 'min-width: 150px;' },
                { key: 'CustomerName', label: 'Customer Name', type: 'text', size: 'min-width: 150px;' },
                { key: 'TotalAttemptCount', label: 'Reattempt', type: 'text', size: 'min-width: 150px;' },
                { key: 'PendingSince', label: 'Pending Days', type: 'text', size: 'min-width: 150px;' },
                { key: 'ReAttemptDate', label: 'Future Pick Date', type: 'text', size: 'min-width: 150px;' },
                { key: 'AssignDate', label: 'Pick Assign Date', type: 'text', size: 'min-width: 70px;' },
                // { key: 'PickupCity', label: 'City', type: 'text', size: 'min-width: 150px;' },
            ],
            Shipmentloader: false,
            tableDataLoader: false,
            //Checkbox
            selectedItemsOnChild: [],
            selectAllCheckbox: false,
            IsCheckbox: true,
            checkboxDisabled: true,
            //Search
            showUnallocatedListFilter: [],
            selectedCount: 0,

            //Process to Allocation
            bindShipmentForAllocation: [],
            sameAddressShipmentForAllocation: [],

            /* MPS Model Param */
            MPSTitle: "",
            MPSSrNameTitle: "",
            MPSNote: "",
            MPSRows: "",
            MPSSelectedRow: "",
            startModelMPS: false,
            MPSAddress: '',
            MPSCount: '',
            MPSActionType: '',

            /* Final Select Dropdown Param */
            outsidesrItemObj: {},
            outsideSrId: '',

            /* PO, P1,P2 info Param*/
            shipmentInfoFlag: false,

            /* Scantally Block Allocation Param */
            isScantallyBatchOpenFlag: false,

            /* Start Trip */
            DeliveryUserIDs: [],

            /* DropDone */
            lastColumnZIndex: 5,
            selectedRow: null,

            /* Search Matching Shipment */
            matchingShipmentRecords: "",
            singlematchingShipmentRecords:"",
            // hubCODPendingLimit: '', //COD Pending Amount limit against SVC
            // IsPendingCODBlock: false,
            codPendingShipData: [],
            codPendingUserData: [],
            hvOnboardingFailMsg: '',
            hvSelieFailMsg: '',
            hvValidationFailedData: [],

            /* Updated Code here */
            svcPriorities: [], // dynamically filled
            srPriorities: [],
        };
    },
    filters: {
        batchCreatedDateFormat: function(date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    computed: {
        filteredTableData() {

            if (this.searchPendingShipment.trim() === '') {
                this.showUnallocatedListFilter = [...this.showUnallocatedList]; // Return all data if the search query is empty
                return this.selectedCount = this.showUnallocatedList.filter(obj => obj.selectedUserID == true).length;
            }
            // Filter table data based on the search query
            return this.showUnallocatedListFilter = this.showUnallocatedList.filter(item =>

                item.ShippingID.toString().toLowerCase().includes(this.searchPendingShipment.toString().toLowerCase()) ||
                item.PickupCity && item.PickupCity.toString().toLowerCase().includes(this.searchPendingShipment.toString().toLowerCase()) ||
                item.CustomerAddress && item.CustomerAddress.toString().toLowerCase().includes(this.searchPendingShipment.toString().toLowerCase()) ||
                item.ClientName && item.ClientName.toString().toLowerCase().includes(this.searchPendingShipment.toString().toLowerCase()) ||
                item.ShipPincode && item.ShipPincode.includes(this.searchPendingShipment)
            );
        }
    },
    created() {
            EventBus.$on('send-data-sr', this.selectSR);
            EventBus.$on('referseFirstPanel',this.CommonGetTableDetails);
    },
    beforeDestroy() {
        EventBus.$off();
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];

        //HyperVerge Messages to show
        this.hvOnboardingFailMsg = this.hyperVMsgData.hvOnboardingFailMsg;
        this.hvSelieFailMsg = this.hyperVMsgData.hvSelieFailMsg;

        // //this.loadUnallocatedShipmentsList();
        // this.loadAllocatedShipmentListInHub()
        //this.GetCount();
        let vm = this;
        Promise.all([
                // await this.GetHubFlags(vm.userHubId),
                this.CommonGetTableDetails(),
                // this.GetDeliverySRList(vm.userHubId),
            ])
            .then((promresult) => {
                console.log('promresult ->', promresult);
            })
            .catch((err) => {
                console.log('error in page load functions', err);
            })
            // this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');

        const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
        const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
        const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
        const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
            //console.log('paperLessKey',paperLessKey);
        if (paperLessKey != null && paperLessKey.trim() == "1") {
            this.IsRVPPaperless = true;
            this.deliveryOptionListPrint.splice(2, 1);
        } else {
            this.IsRVPPaperless = false;
        }
        // console.log('this.IsRVPPaperless', this.IsRVPPaperless);
    },
    methods: {
        closeRvpShipmentsModel() {
            this.morePendingRVPShipmentsModel = false;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChangedSuccess(dismissCountDownSuccess) {
            this.dismissCountDownSuccess = dismissCountDownSuccess
        },
        allocatePickups() {
            if (this.SrId != '') {
                if (this.PassEOD == false) {
                    this.$alertify.error('Day end closure has not been performed by selected SR.!')
                } else {
                    this.UNLoading = true;
                    this.selectedPickupsMore = []
                    this.getPendingForRVPList().then((result) => {
                        if (result.success) {
                            this.morePendingRVPShipmentsModel = true
                            this.isActiveRvp = true
                            this.UNLoading = false;
                        } else {
                            this.allocatePickupShipment()
                            this.UNLoading = false;
                        }
                    });
                }
            } else {
                this.$alertify.error('Please select SR to allocate shipments.!')
            }
        },
        selectAllMoreRVPShipments() {
            if (this.sAllMoreShip) {
                this.suggestRVPArrayList.forEach((data) => {
                    this.selectedPickupsMore.indexOf(data.ShippingId) == -1 ? this.selectedPickupsMore.push(data.ShippingId) : ''
                })
            } else {
                this.selectedPickupsMore = []
            }
        },
        getPendingForRVPList() {
            this.errorRvpAllocation = "";
            this.successRvpAllocation = '';
            return new Promise((resolve, reject) => {
                this.suggestRVPArrayList = []
                var relShippingIds = []
                let reqPayload = { ShippingID: this.UASelectedArr }
                getSameCustomerShipmentsforRVP(reqPayload, (response) => {
                    try {

                        var resultData = response.data
                        if (resultData.code == 200 && typeof resultData.data !== 'undefined') {
                            var result = resultData.data
                            for (var i = 0; i < result.length; i++) {
                                if (result[i].ReversePickUpData.length > 0) {
                                    let tempData = result[i].ReversePickUpData
                                    for (var j = 0; j < tempData.length; j++) {
                                        relShippingIds.push(tempData[j])
                                    }
                                }
                            }

                            if (relShippingIds.length > 0) {
                                for (var i = 0; i < relShippingIds.length; i++) {
                                    for (var j = 0; j < this.UASelectedArr.length; j++) {
                                        if (relShippingIds[i] == this.UASelectedArr[j]) {
                                            // console.log('Success', relShippingIds[i]);
                                            relShippingIds.splice(i, 1);
                                            // i = i-1;
                                        }
                                    }
                                }
                                var uniqueArray = []
                                for (var i = 0; i < relShippingIds.length; i++) {
                                    if (uniqueArray.indexOf(relShippingIds[i]) === -1) {
                                        uniqueArray.push(relShippingIds[i]);
                                    }
                                }

                                var suggestRVPArrayList = []
                                    // console.log('uniqueArray ---------->>', uniqueArray);
                                for (var i = 0; i < this.showUnallocatedList.length; i++) {
                                    if (uniqueArray.includes(this.showUnallocatedList[i].ShippingId)) {
                                        this.suggestRVPArrayList.push(this.showUnallocatedList[i]);
                                    }
                                }
                                resolve({ success: true });
                            }
                        } else {
                            resolve({ success: false });
                        }

                    } catch (e) {
                        console.log('result------', result);
                        // console.log('ERRORRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR', e);
                    }
                })
            });
        },
        preMPSValidationCheck() {
            this.continueloader = true
            this.getSameMPSGroupShipments().then((result) => {
                if (result.success) {
                    this.morePendingRVPShipmentsModel = true
                    this.isActiveRvp = true
                    if (this.IsrvpMPSAllocation) {

                        let mpsGroupShipments = this.holdTempMPSData
                        let mpsCount = mpsGroupShipments.length
                        if (mpsGroupShipments.length > 0) {
                            let filterArray = mpsGroupShipments.filter(person => this.selectedPickupsMore.includes(person.ShippingId));
                            if (filterArray.length == mpsGroupShipments.length) {
                                // console.log('Proceed For Success.!!!!!!!!!!');
                                this.allocatePickupShipment()
                            } else {
                                this.sameCustomerTitle = 'Mandatory to allocate MPS Shipments.'
                                this.$alertify.error('Please allocate same mps shipment to one SR.!')
                            }
                        } else {
                            this.allocatePickupShipment()
                            console.log('Proceed Without MPS Success.!!!!!!!!!!');
                        }
                    }
                    this.continueloader = false
                } else {
                    this.isLoadingASL = true;
                    this.allocatePickupShipment()
                    this.continueloader = false
                }
            });
        },
        getSameMPSGroupShipments() {
            this.IsrvpMPSAllocation = false
            return new Promise((resolve, reject) => {
                let holdTempData = []
                this.holdTempMPSData = []
                let len = this.UASelectedArr.length;
                for (let i = 0; i < len; i++) {
                    let getObj = this.showUnallocatedList.find(obj => obj.ShippingId == this.UASelectedArr[i])
                    if (getObj && getObj != 'undefined') {
                        let mpsShipments = this.showUnallocatedList.forEach(mpscheck => {
                            if (mpscheck.MultiShipmentGroupID != '' && mpscheck.MultiShipmentGroupID != null && mpscheck.MultiShipmentGroupID != 'null' && mpscheck.MultiShipmentGroupID == getObj.MultiShipmentGroupID) {
                                if (!this.UASelectedArr.includes(mpscheck.ShippingId)) {
                                    if (this.holdTempMPSData.length > 0) {
                                        let isExist = this.holdTempMPSData.find(o => o.ShippingId == mpscheck.ShippingId)

                                        if (isExist) {} else {
                                            this.holdTempMPSData.push(mpscheck);

                                        }

                                    } else { this.holdTempMPSData.push(mpscheck); }

                                }
                            }
                        })
                    }
                }

                if (this.holdTempMPSData.length > 0) {
                    this.IsrvpMPSAllocation = true
                    this.suggestRVPArrayList = this.holdTempMPSData
                    resolve({ success: true });
                } else {
                    this.IsrvpMPSAllocation = false
                    resolve({ success: false });
                }
            })
        },
        selectedItemdataEvent(selectedItems) {
            this.selectedItems = [];
            this.UASelectedArr = []
            this.selectedItems = selectedItems
            for (let i = 0; i < this.selectedItems.length; i++) {
                this.UASelectedArr.push(this.selectedItems[i].ShippingId)
            }
        },

        loadAllocatedDetails() {
            this.AllocatedFwdShipmentData();
        },

        SaveEBNData(scope) {
            this.errVehicleNo = "";
            this.$validator.validateAll(scope).then(result => {
                    if (result) {

                        this.ebnDataLoader = true
                        this.allocatePickupShipment()
                    } else {
                        console.log('failed Success ebn', this.$validator);
                    }
                })
                .catch(() => {
                    console.log('errors exist', this.errors)
                });
        },
        closevehiclePopup() {
            this.storeAns = [];
            this.EBNshippingData = [];
            this.vehicleNumbers = {};
            this.bindShipmentForAllocation = [];
            this.vehiclePopup = false
        },
        clearallocationFields() {
            // this.IsReload = false;
            this.selectedPickupsMore = []
            this.suggestRVPArrayList = []
            this.morePendingRVPShipmentsModel = false
            this.IsrvpMPSAllocation = false
            this.sAllMoreShip = []
            this.UASelectedArr = []
            this.bindShipmentForAllocation = [];
            this.outsidesrItemObj = '';
            this.outsideSrId = '';
            this.matchingShipmentRecords = '';
            this.CommonGetTableDetails();
            //this.loadUnallocatedShipmentsList();
        },
        async selectSR(obj) {
            // EventBus.$off('send-data-sr');
            // this.checkScantallyBatchClosedOrNot(this.userHubId);
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.errorRvpAllocation = "";
            this.successRvpAllocation = '';
            this.errorRvpAllocationErrorArrobj = [];
            this.isAllocation = false
            this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;
            this.OldUserid = obj.OldUserid;
            this.EmpType = obj.EmpType;
            this.CourierCompanyID = obj.CourierCompanyID;
            this.MobileNumber = obj.MobileNumber;
            this.IsSRNeedTrip = obj.IsSRNeedTrip;
            this.vehicleTypeFlag = false;
            this.tripDayflag = 0;
            this.disableprint = true;
            //this.AllocatedFwdShipmentData();
            //this.PreviousDayShipmentList();
            //this.SameRouteShipmentList();

            if(!obj.ishvonboardingdone || !obj.isselfieverified){
                let hyperVFailureMsg = !obj.ishvonboardingdone ? this.hvOnboardingFailMsg : this.hvSelieFailMsg;
                this.hideAllocateFlag = false;
                return this.$alertify.error(hyperVFailureMsg);
            }

            const eodShipValidation = await this.validateEODAllocation();
            if(eodShipValidation || obj.isCodLimitBreached){
                let alertMsg = eodShipValidation ? eodShipValidation : 'Please clear the pending COD Amount against the user and try again.'
                return this.$alertify.error(alertMsg);
            }
            this.CommonGetTableDetails();
            if (this.EmpType == null || this.EmpType == "") {
                this.$alertify.error("EmpType not found against this SR, EmpType is required.")
            } else if (this.IsSRNeedTrip == true) {
                this.TopReset = false
                this.IsSRNeedTrip = true
                this.tripDayflag = 0;
                this.SRSelectingloader = true;
                this.vehicleType = ""
                this.srVehicleList = []
                this.vehicleNoItemObj = {
                    value: '',
                    text: ''
                }
                this.vehicleOpenKM = ''
                this.vehicleNo = ''
                this.vehicleVendorId = 0
                this.startAllocationFlag = false
                this.tripTitle = 'Start Trip'
                this.errorCloseKM = ''
                this.errorOpenKM = ''
                this.closeKm = ''
                this.tripState = ''
                this.ValiadteTripdetails();
            }
        },
        // GetDeliverySRList(hubid) {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             this.srLoader = this.loader;
        //             this.srArrayList = [];
        //             this.srList = [];
        //             let RVPPayload = {
        //                 "usertype": "3",
        //                 "hubid": [hubid]
        //             }
        //             getHubDeliverySRListByHubID(RVPPayload, (result) => {
        //                 try {

        //                     this.srArrayList = result.data.data.results;
        //                     for (var i = 0; i < this.srArrayList.length; i++) {
        //                         this.srList.push({
        //                             value: this.srArrayList[i].userid,
        //                             text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
        //                             OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
        //                             EmpType: this.srArrayList[i].EmpType,
        //                             CourierCompanyID: this.srArrayList[i].CourierCompanyID,
        //                             MobileNumber: this.srArrayList[i].MobileNumber,
        //                             IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR
        //                         })
        //                     }
        //                     this.srLoader = '';
        //                     this.CommonGetTableDetails();
        //                 } catch (e) {
        //                     console.log('result------', result);
        //                 }
        //             })
        //             resolve(true);
        //         } catch (err) {
        //             console.log('Error Logs forGetDeliverySRList', err);
        //             resolve(false);
        //         }
        //     })
        // },
        selectFrom(obj) {
            this.fromItemObj = obj
            this.fromId = obj.value
        },

        // GetHubFlags() {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             let HubFlagsRVPPayload = {
        //                 "Outsourceid": 4,
        //                 "hubid": this.userHubId
        //             }
        //             GetHubFlags2(HubFlagsRVPPayload, (result) => {
        //                 if (result.data.data.code == 200) {
        //                     this.isRSVSr = result.data.data.data.IsRSVSr;
        //                     const hubCodLimit = result.data.data.data.configSetting.CODPendingLimit;
        //                     this.hubCODPendingLimit = (hubCodLimit && hubCodLimit != 0) ? hubCodLimit : null;
        //                     this.IsPendingCODBlock = result.data.data.data.configSetting.IsPendingCODBlock;       
        //                 } else {
        //                     this.$alertify.error(result.data.data.message)
        //                 }
        //                 resolve(true)
        //             })
        //         } catch (e) {
        //             console.log('error logs..', e);
        //             resolve(true)
        //         }
        //     })
        // },
        selectClient(obj) {
            this.ClientObj = obj;
            this.Clientname = obj.value
        },
        selectClient2(obj) {
            this.ClientObj2 = obj;
            this.Clientname2 = obj.value
        },
        selectServiceType(obj) {
            this.ServiceTypeObj = obj;
            this.ServiceType = obj.text
        },
        selectWeightG(obj) {
            this.WeightGObj = obj;
            this.WeightGroup = obj.text
        },
        selectEscalation(obj) {
            this.EscalationObj = obj;
            this.Escalation = obj.value
        },

        selectCluster(obj) {
            this.ClusterObj = obj;
            this.ClusterId = obj.value
        },
        async validateEODAllocation() {
            return new Promise((resolve, reject)=>{
                let EODvalidationdata = {
                    "DeliveryUserID": this.SrId,
                    "HubID": this.userHubId
                }
                EODValidation(EODvalidationdata, (result) => {
                    if (result.data.code === 202) {
                        this.hideAllocateFlag = false
                        resolve(result.data.message);
                    } else {
                        this.hideAllocateFlag = true;
                        this.PassEOD = true;
                        resolve(false);
                    }
                    this.TopReset = false
                })
            })
        },
        ValiadteTripdetails() {
            let TripDetailsRVPPayload = {
                "XBkey": "XB123",
                "HubId": this.userHubId,
                "DeliveryUserId": this.SrId
            }
            GetTripdetails(TripDetailsRVPPayload, (result) => {
                if (result.data.TripState == "closed") {
                    this.tripState = 'created'
                    this.startTripFlag = true
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "created" || result.data.TripState == "start") {
                    this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
                    this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
                    if (this.tripCreatedDate == this.currentDateTime) {
                        this.tripDayflag = 0;
                        this.tripDateFlag = false;
                    } else {
                        this.tripDayflag = result.data.tripDayflag
                        this.tripDateFlag = true;
                    }
                    this.startTripFlag = true
                    this.tripState = result.data.TripState
                    this.tripTitle = "Continue trip"
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "deliveryuserclosed" && result.data.code == 200) {
                    this.openKM = result.data.OpenKM
                    this.openKmImg = result.data.OpenKMImageUrl
                    this.closeKmImg = result.data.CloseKMImagUrl
                    this.originCloseImg = result.data.CloseKMImagUrl
                    this.tripId = result.data.TripId
                    this.srVehicleNo = result.data.VehicleNo
                    this.openKm = result.data.OpenKM
                    this.startTripModelFlag = false;
                    this.closeTripModel = true
                    this.SRSelectingloader = false;
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                }
            }, error => {
                console.error(error)
            })
        },
        startTrip() {
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            if (this.tripTitle == 'Start Trip') {
                this.vehicleTypeFlag = true
            } else {
                this.startAllocation(false)
            }
        },
        selectVehicleNo(obj) {
            this.vehicleNoItemObj = obj
            this.vehicleNo = obj.text
            this.vehicleVendorId = obj.value
        },
        loadVehicleDetails(type) {
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.startAllocationFlag = false
            this.vehicleType = type
            this.srVehicleList = []
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleOpenKM = ''
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (type == "bike") {
                let payload = {
                    "srid": this.SrId,
                    "hubid": this.userHubId
                }
                BikeVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        var srVehicleList = result.data.data.data
                        for (var i = 0; i < srVehicleList.length; i++) {
                            this.srVehicleList.push({ value: srVehicleList[i].VehicleNumber, text: srVehicleList[i].VehicleNumber })
                        }
                    }
                })
            } else if (type == "vehicle") {
                let payload = {
                    "HubId": this.userHubId
                }
                VehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        if (type == "vehicle") {
                            var srVehicleList = result.data.data.Data
                            for (var i = 0; i < srVehicleList.length; i++) {
                                this.srVehicleList.push({
                                    value: srVehicleList[i].VendorVehicleId,
                                    text: srVehicleList[i].VehicleNumber
                                })
                            }
                        }
                    }
                })
            } else if(type == "adhoc"){
                let payload = {
                    "HubId": this.userHubId
                }
                AdhocVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        if (type == "adhoc") {
                            var adhocVehicleList = result.data.data.Data;
                            for (var i = 0; i < adhocVehicleList.length; i++) {
                                this.srVehicleList.push({
                                    value: adhocVehicleList[i].VehicleNumber,
                                    text: adhocVehicleList[i].VehicleNumber
                                })
                            }
                        }
                    }
                })
            }
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        startAllocation(flag) {
            this.flagShowPreviousShipment = false
            this.startAllocationFlag = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            var decimal = /^\d+(\d{1,2})?$/;
            if (decimal.test(this.vehicleOpenKM) == false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No1"
                this.errVehicleKm = "Enter Correct KM"
            } else if (this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
            } else if (decimal.test(this.vehicleOpenKM) == false && flag) {
                this.errVehicleKm = "Enter Correct KM"
            } else if (flag && this.vehicleOpenKM > 1000000) {
                this.errVehicleKm = "Open Km should be less than 1000000"
            } else {
                this.startAllocationFlag = true
                if (flag) {
                    this.TripCreation();
                }
            }
        },
        TripCreation() {
            this.allocationLoader = true;
            let RVPPayload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "RVP",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "operationType": "lastmile"
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                RVPPayload['isvehicleupdated'] = true
            } else {
                RVPPayload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                RVPPayload['vehiclevendorid'] = this.vehicleVendorId
            }
            CreateTrip(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "createTrip",
                            "srname": this.SrName,
                            "triptype": "RVP",
                            "hubid": this.userHubId
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.startAllocationFlag = true;
                    this.$alertify.success(result.data.message);
                    this.CloseModelStartTrip()

                } else if (result.data.code == 202) {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message.details[0].message);
                } else {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                }
                this.allocationLoader = false;
            }, error => {
                this.startAllocationFlag = false;
                this.$alertify.error('Failed to Create Trip, Please retry!');
                this.allocationLoader = false;
                console.error(error)
            })
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        loadOpenImageError(imageSrc, type) {
            var srcLink = "static/img/defaultImg.png"
            this.openKmImg = srcLink
        },
        loadCloseImageError(imageSrc) {
            var srcLink = "static/img/defaultImg.png"
            this.originCloseImg = imageSrc
            this.closeKmImg = srcLink
        },
        verifyTrip() {
            if (this.openKm >= 1000000) {
                this.errorOpenKM = "Open Km should be less than 1000000";
            } else {
                this.errorOpenKM = '';
                if (parseFloat(this.closeKm) > parseFloat(this.openKm)) {
                    let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
                    if (calculatekm < 200) {
                        this.errorCloseKM = '';
                        let RVPPayload = {
                            "XBkey": "XB123",
                            "tripid": this.tripId,
                            "sruserid": this.SrId.toString(),
                            "hubid": this.userHubId,
                            "km": this.closeKm,
                            "Openkm": this.openKm,
                            "tripstate": "closed",
                            "vehicleno": this.srVehicleNo,
                            "isvehiclereplaced": false,
                            "lastmodifiedby": this.createdBy,
                            "operationType": "lastmile"
                        }
                        CloseTrip(RVPPayload, (result) => {
                            if (result.data.code == 200) {
                                let TrackerInfo = {
                                    projectname: "Last Mile",
                                    type: "Web",
                                    userid: this.userid,
                                    username: this.createdBy,
                                    meta: {
                                        "event": "closeTrip",
                                        "tripid": this.tripId,
                                        "sruserid": this.SrId.toString()
                                    }
                                }
                                this.PageTracker(TrackerInfo);
                                this.$alertify.success(result.data.message)
                                this.closeTripModel = false
                                this.Reset();
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        })
                    } else {
                        this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
                    }
                } else {
                    this.errorCloseKM = "Close KM should be greater then open KM"
                }
            }
        },
        closeCloseTripModel() {
            this.closeTripModel = false
            this.startTripModelFlag = true;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChangedSuccess(dismissCountDownSuccess) {
            this.dismissCountDownSuccess = dismissCountDownSuccess
        },
        selectReason(obj) {
            this.ReasonObj = obj;
            this.Reason = obj.text
        },
        CheckPDD() {
            this.CloseNonAllocationRsn()
            let Payload = {
                "DeliveryUserId": this.SrId,
                "HubId": this.userHubId.toString(),
                "shipmenttype": "RVP",
            }
            GetNonAllocationSEQ(Payload, (result) => {
                if (result.data.code == 200 && result.data.data.length > 0) {
                    this.SeqArray = result.data.data.filter(x => (x.result != 0))
                    this.BucketName = this.SeqArray[0].Bucket
                    this.TitleName = this.SeqArray[0].title
                    this.resultCount = this.SeqArray[0].result
                    this.SEQShippingids = this.SeqArray[0].shippingids
                    this.arrReasonList = this.SeqArray[0].Reason.split(",")
                    for (let i = 0; i < this.arrReasonList.length; i++) {
                        this.ReasonList.push({
                            text: this.arrReasonList[i],
                        })
                    }
                    this.NonAllocationRsn = true
                } else {
                    this.confirmTrip();
                    this.CloseNonAllocationRsn()
                }
            })
        },
        StoreNonAllocationSeq() {
            this.CloseNonAllocationRsn();
            this.TitleName = this.SeqArray[0].title
            this.BucketName = this.SeqArray[0].Bucket
            this.resultCount = this.SeqArray[0].result
            this.SEQShippingids = this.SeqArray[0].shippingids
            this.arrReasonList = this.SeqArray[0].Reason.split(",")
            for (let i = 0; i < this.arrReasonList.length; i++) {
                this.ReasonList.push({
                    text: this.arrReasonList[i],
                })
            }
            this.NonAllocationRsn = true
        },
        CloseNonAllocationRsn() {
            this.BucketName = ''
            this.TitleName = ''
            this.Reason = ''
            this.ReasonObj = {
                text: ""
            }
            this.resultCount = 0,
                this.SEQShippingids = []
            this.ReasonList = []
            this.NonAllocationRsn = false
        },
        SubmitNonAllocationRsn() {
            let Payload = {
                "DeliveryUserId": this.SrId,
                "Reason": this.Reason,
                "Bucket": this.BucketName,
                "CreatedBy": this.createdBy,
                "shippingids": this.SEQShippingids,
                "pendingcount": this.resultCount
            }
            StoreReason(Payload, (result) => {
                if (result.data.code == 200) {
                    this.$alertify.success("Reason Submitted Successfully!!")
                    this.CloseNonAllocationRsn();
                    this.SeqArray.splice(0, 1)
                    if (this.SeqArray.length > 0) {
                        this.StoreNonAllocationSeq();
                    } else {
                        this.confirmTrip();
                    }
                } else if (result.data.code == 204) {
                    this.$alertify.error('Reason is required.')
                }
            })
        },
        async confirmTrip() {
            this.allocationSuccessMsg = ''
            this.isConfirmLoad = true;
            this.showParentGroupIdShipmentList = [];
            let RVPPayload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "RVP",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "LastModifiedBy": this.createdBy,
                "MarkedFrom": this.fromId,
                "operationType": "lastmile",
                "isHandoverDeliveryUser": 1
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                RVPPayload['isvehicleupdated'] = true
            } else {
                RVPPayload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                RVPPayload['vehiclevendorid'] = this.vehicleVendorId
            }
            ConfirmShipment(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "confirmShipment",
                            "sruserid": this.SrId.toString(),
                            "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                            "triptype": "RVP",
                            "srname": this.SrName,
                            "isvehiclereplaced": this.isVehicleReplaced,
                            "MarkedFrom": this.fromId,
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.isAllocation = false
                    this.$alertify.success(result.data.message)
                    this.AllocatedFwdShipmentData();
                    //this.loadAllocatedShipmentListInHub();
                    this.fromId = "UA";
                    this.errorRvpAllocation = "";
                    this.successRvpAllocation = '';
                    this.errorRvpAllocationErrorArrobj = [];
                } else {
                    if (result.data.status == 208) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.message;
                        this.showParentGroupIdShipmentList = result.data.data;
                    } else {
                        this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                    }
                }
                this.isConfirmLoad = false;
            }, error => {
                console.error(error)
                this.isConfirmLoad = false;
            })
        },
        srAllocatedPagination(pageNum) {
            this.srallocatePageNumber = pageNum;
            this.AllocatedFwdShipmentData();
        },
        AllocatedFwdShipmentData() {
            this.isAllocation = false
            this.AllocateTableLoader = true
            this.AllocatedList = []
            this.srAllocatedTotalCount = 0
            let AllocatedShipmentRVPPayload = {
                "HubId": (this.userHubId).toString(),
                "ShipmentType": "RVP",
                "DeliveryUserId": this.SrId,
                "pageNumber": this.srallocatePageNumber,
                "pageLimit": this.srAllocatedPageLimit
            }
            AllocatedFwdShipmentDetails(AllocatedShipmentRVPPayload, (result) => {

                if (result.status == 200 && result.data.code == 200) {
                    this.AllocatedList = result.data.data.rows
                    this.srAllocatedTotalCount = result.data.data.count;
                    if (this.AllocatedList.length > 0) {
                        this.isAllocation = true
                    }
                    if (this.srAllocatedTotalCount < this.srAllocatedPageLimit) {
                        this.srAllocatedPageCount = 1
                    } else {
                        this.srAllocatedPageCount = Math.ceil(this.srAllocatedTotalCount / this.srAllocatedPageLimit);
                    }
                    this.AllocateTableLoader = false
                } else if (result.status == 200 && result.data.code != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                } else if (result.status != 200) {
                    this.srAllocatedTotalCount = 0
                    this.srAllocatedPageCount = 1
                    this.AllocateTableLoader = false
                }
            })
        },
        hubAllocatedPagination(pageNum) {
            this.huballocatePageNumber = pageNum;
            //this.loadAllocatedShipmentListInHub();
        },
        RemoveShipment(shippingId) {
            let RVPPayload = {
                XBkey: "XB123",
                ShippingID: shippingId,
                LastModifiedBy: this.createdBy,
            }
            RemoveAllocatedShipment(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "RemoveShipment",
                            "ShippingID": shippingId.toString()
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.AllocatedFwdShipmentData();
                    //this.loadAllocatedShipmentListInHub();
                    //this.loadUnallocatedShipmentsList();
                    this.$alertify.success("Shipment Successfully Removed")
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
            }, error => {
                console.error(error)
            })
        },

        PreviousDayShipmentList() {
            this.PDTableLoader = true;
            this.SuggestionList = [];
            if (this.SrId == '') {
                this.PDTableLoader = false;
            }
            let PreviousDayRVPPayload = {
                "HubId": (this.userHubId).toString(),
                "DeliveryUserId": this.SrId,
                "shipmenttype": "RVP",
            }
            PreviousDayShipmentDetails(PreviousDayRVPPayload, (result) => {
                this.SuggestionList = result.data.data
                this.PDTableLoader = false;
            })
            this.PDTableLoader = false;
        },
        SameRouteShipmentList() {
            this.SMTableLoader = true
            this.SameRouteList = [];
            if (this.SrId == '') {
                this.SMTableLoader = false;
            }
            let SameRouteRVPPayload = {
                "DeliveryUserId": this.SrId,
                "HubId": (this.userHubId).toString(),
                "shipmenttype": "RVP",
            }
            SameRouteShipments(SameRouteRVPPayload, (result) => {
                this.SameRouteList = result.data.data
                this.SMTableLoader = false;
            })
            this.SMTableLoader = false;
        },
        HandleDragOver(event) {
            event.preventDefault();
        },
        OnlyNumber: function($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
                $event.preventDefault();
            }
        },
        OpenPrintShipmentModal() {

            this.PrintShipmentModal = true
            this.EnableHyperLink = false
        },
        closePrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentModal = false,
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        ResetPrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentsList = [],
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        GetShipmentPrintdetails() {
            this.PrintShipmentDetails();
            this.ShowPrintTable = true
        },
        PrintShipmentDetails() {
            this.PrintShipmentsList = [];
            this.isLoadBatch = true;
            let batchCdate = moment(this.batchCreatedDate).format('YYYY-MM-DD');
            this.today = new Date();
            let Today = moment(this.today).format('YYYY-MM-DD');
            if (batchCdate == Today) {
                this.EnableHyperLink = true;
            }
            let batchRVPPayload = {
                "UserHubID": this.userHubId.toString(),
                "DeliveryUserID": this.SrId,
                "shipmentType": "RVP",
                "createdDate": batchCdate
            }
            ShipmentPrintDetails(batchRVPPayload, (result) => {
                if (result.data.code == 200) {
                    this.isLoadBatch = false
                    for (var i = 0; i < result.data.PrintBatchId.length; i++) {
                        this.shippingIDArray = []
                        for (var j = 0; j < result.data.PrintBatchId[i].NoOfShipments; j++) {
                            this.shippingIDArray.push({
                                shippingIDArray: result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                            })
                            this.ResCreatedDate = moment(result.data.PrintBatchId[i].ShippingIDs[j].CreatedDate).format('DD-MM-YYYY')
                        }
                        this.PrintShipmentsList.push({
                            AssignBatchNo: result.data.PrintBatchId[i].AssignBatchNo,
                            NoOfShipments: result.data.PrintBatchId[i].NoOfShipments,
                            shippingIDArray: this.shippingIDArray,
                            SrName: this.SrName,
                            CreatedDate: this.ResCreatedDate
                        })
                    }
                } else {
                    this.isLoadBatch = false
                    this.$alertify.error(result.data.message)
                }
            }, error => {
                console.error(error)
            })
        },
        exportCSVOfShippingIDS(result) {
            let csvContent = "data:text/csv;charset=utf-8,";
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            var today = dd + "" + mm + "" + yyyy;
            let filename = "ShippingID" + today + ".csv";
            csvContent += ['ShippingID',
                    ...result.map(item => Object.values(item).join(";"))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", filename);
            link.click();
        },

        PrintShipment(AssignBatchNo) {
            this.isLoadPDF = true
            this.input = {
                "DeliveryUserID": this.SrId,
                "ShipmentType": "RVP",
                "BatchId": AssignBatchNo,
                "PrintType": "RVP",
                "UserName": this.createdBy,
                "PrintFrom": 'FromWeb'
            }
            pdfData(this.input, (result) => {
                if (result.status == 200) {
                    const downloadUrl = window.URL.createObjectURL(new Blob([result.data], {
                        type: 'application/pdf'
                    }))
                    let message = {
                        title: '',
                        body: `<p>Pdf is generated, Would you like to open.!</p>`,
                    };

                    let res = this.$dialog.alert(message, {
                            html: true,
                            animation: 'bounce',
                            backdropClose: false,
                            loader: true
                        })
                        .then(dialog => {
                            window.open(downloadUrl);
                            this.isLoadPDF = false
                            dialog.close();
                        })
                        .catch(() => {
                            this.isLoadPDF = false
                        })
                } else {
                    this.isLoadPDF = false;
                    this.$alertify.error('Unable to load pdf, Please try after sometime.!');
                }
            }, error => {
                this.isLoadPDF = false;
                console.error(error)
            })
        },
        // GetCount() {
        //     this.CountLoading = true;
        //     let RVPPayload = {
        //         "shipmenttype": "RVP",
        //         "hubid": this.userHubId.toString()
        //     }
        //     GetShipmentCount(RVPPayload, (result) => {
        //         let CountARR = [];
        //         if (result.data.code == 200) {
        //             CountARR = result.data.data[0]
        //             this.AllCount = CountARR.all
        //             this.tobeAttemptedTodayCount = CountARR.tobeAttemptedToday
        //             this.pddBreachedCount = CountARR.pddBreached
        //             this.PDDBreachedinNext24hrsCount = CountARR.PDDBreachedinNext24hrs
        //             this.fakeAttemptsCount = CountARR.fakeAttempts
        //             this.CountLoading = false;
        //         } else {
        //             this.CountLoading = false;
        //             this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
        //         }
        //     })
        // },
        unallocatedgetPaginationData(pageNum) {
            this.unallocatePageNumber = pageNum;
            //this.loadUnallocatedShipmentsList();
        },
        async GetCurrentScreenValue(currentVal) {
            // console.log("currentValllllllll", currentVal);
            this.currentScreenTab = currentVal;
            if (this.currentScreenTab == 'PDDBreached') {
                this.Pddbreached = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'TobeAttemptedToday') {
                this.Tobeattempted = true;
                this.IsAllData = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'PDDBreachedinNext24hrs') {
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = true;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'FakeAttempts') {
                this.FakeAttempt = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            } else {
                this.IsAllData = true;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            }
            //this.loadUnallocatedShipmentsList();
        },

        // loadUnallocatedShipmentsList() {
        //     let reqRVPPayload = {
        //         "shipmenttype": "RVP",
        //         "hubid": this.userHubId,
        //         "pagenumber": this.unallocatePageNumber,
        //         "pagelimit": this.unallocatePageLimit,
        //         "isAllData": this.IsAllData,
        //         "tobeattempted": this.Tobeattempted,
        //         "pddbreached": this.Pddbreached,
        //         "pddbreachedinnext24hours": this.Pddbreachedinnext24hours
        //     }
        //     if (this.AccAWBNumbers != "") {
        //         let shipingID = this.AccAWBNumbers.split(/[\s,]+/);
        //         let shipmentArray = [];
        //         $.each(shipingID, (key, AccAWBNumbers) => {
        //             if (AccAWBNumbers != '') {
        //                 shipmentArray.push(AccAWBNumbers.trim())
        //             }
        //         })
        //         reqRVPPayload.shipmentid = shipmentArray;
        //     }
        //     if (this.Clientname) {
        //         reqRVPPayload.clientid = this.Clientname
        //     }
        //     if (this.ServiceType) {
        //         reqRVPPayload.servicetype = this.ServiceType
        //     }
        //     if (this.WeightGroup) {
        //         reqRVPPayload.weightgroupid = this.WeightGroup
        //     }
        //     if (this.ClusterId) {
        //         reqRVPPayload.clusterid = this.ClusterId
        //     }
        //     if (this.Escalation) {
        //         reqRVPPayload.Escalation = this.Escalation
        //     }
        //     if (this.rvpAddress) {
        //         reqRVPPayload.pincode = this.rvpAddress
        //     }
        //     this.getPendingShipmentforAllocation(reqRVPPayload)
        // },
        // getPendingShipmentforAllocation(RVPPayloadobj) {
        //     this.IsReload = true;

        //     this.UATableLoader = true
        //     this.showUnallocatedList = [];
        //     this.unallocateTotalCount = [];
        //     getUnallocatedShipments(RVPPayloadobj, (result) => {
        //         console.log('VENKY ------------>>', result);
        //         if (result.status == 200 && result.data.code == 200) {
        //             this.showUnallocatedList = result.data.data
        //             this.unallocateTotalCount = result.data.totalCount;

        //             if (this.unallocateTotalCount < this.unallocatePageLimit) {
        //                 this.unallocatepageCount = 1
        //             } else {
        //                 this.unallocatepageCount = Math.ceil(this.unallocateTotalCount / this.unallocatePageLimit);
        //             }
        //             this.UATableLoader = false

        //         } else if (result.status == 200 && result.data.code != 200) {
        //             this.unallocatepageCount = 1
        //             this.UATableLoader = false
        //         } else if (result.status != 200) {
        //             this.unallocatepageCount = 1
        //             this.UATableLoader = false
        //         }
        //         this.IsReload = false;

        //     })
        // },
        Reset() {
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.TopReset = true;
            this.currentScreenTab = 'ALL';
            this.AllocateTableLoader = false;
            this.shipmentNo = '';
            this.srAllocatedTotalCount = 0;
            this.SuggestionList = [];
            this.SameRouteList = [];
            this.AllocatedList = [];
            this.Clientname = '';
            this.fromId = "UA";
            this.disableprint = false;
            this.SrId = '';
            this.SrName = '';
            this.srItemObj = {};
            this.continueloader = false;
            this.CountLoading = false;
            this.AllocateTableLoader = false;
            this.PDTableLoader = false;
            this.SMTableLoader = false;
            this.currentDateTime = '';
            this.tripDayflag = '';
            this.tripCreatedDate = '';
            this.tripDateFlag = false;
            this.IsSRNeedTrip = false;
            this.isVehicleReplacedCheck = 0;
            this.isVehicleReplaced = false;
            this.errVehicleNo = "";
            this.errVehicleKm = "";
            this.tripTitle = 'Start Trip';
            this.isRSVSr = 0;
            this.startTripFlag = false;
            this.vehicleTypeFlag = false;
            this.vehicleType = "";
            this.vehicleNoItemObj = {};
            this.vehicleNo = '';
            this.vehicleVendorId = 0;
            this.vehicleOpenKM = '';
            this.startAllocationFlag = false;
            this.isAllocation = false;
            this.tripId = '';
            this.openKm = '';
            this.openKmImg = '';
            this.closeKm = '';
            this.closeKmImg = '';
            this.originCloseImg = '';
            this.srVehicleNo = '';
            this.errorCloseKM = '';
            this.errorOpenKM = '';
            this.flagShowPreviousShipment = false;
            this.PDLoading = false;
            this.SMLoading = false;
            this.UNLoading = false;
            this.SRSelectingloader = false;
            this.PDSelectedArr = [];
            this.SMSelectedArr = [];
            this.AllocateTableLoader = false;
            this.PDTableLoader = false;
            this.SMTableLoader = false;
            this.UATableLoader = false;
            this.HUbAllocatedTableLoader = false;
            this.CountLoading = false;
            this.ebnDataLoader = false;
            this.bindShipmentForAllocation = [];
            this.isScantallyBatchOpenFlag = false;
            this.searchPendingShipment = "";
            this.matchingShipmentRecords = "";
            this.outsideSrId = "";
            this.selectedItemsOnChild = [];
            this.errorRvpAllocationErrorArrobj = [];
            this.successRvpAllocation = '';
            this.CommonGetTableDetails();
            return true;
        },
        RightTabReset() {
            this.ResetLoader = true;
            this.currentScreenTab = 'ALL';
            this.IsReload = true;
            this.UASelectedArr = [];
            this.selectedItems = [];
            this.IsAllData = true;
            this.HUbAllocatedTableLoader = false;
            this.CountLoading = false;
            this.IsAllData = true;
            this.Tobeattempted = false;
            this.Pddbreached = false;
            this.Pddbreachedinnext24hours = false;
            this.FakeAttempt = false;
            this.startAllocationFlag = false;
            this.Clientname = '';
            this.ClientObj = {};
            this.ServiceType = '';
            this.ServiceTypeObj = {};
            this.ClusterId = '';
            this.ClusterObj = {};
            this.WeightGroup = '';
            this.WeightGObj = {};
            this.AccAWBNumbers = "";
            this.rvpAddress = '';
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.selectedPickupsMore = [];
            this.errorRvpAllocation = "";
            this.successRvpAllocation = '';
            this.errorRvpAllocationErrorArrobj = [];
            this.ShipmentFutureFailedArrObj = [];
            this.ShipmentFailedArrObj = [];
            this.EBNshippingData = [];
            //this.loadUnallocatedShipmentsList();
            this.ResetLoader = false;
            this.bindShipmentForAllocation = [];
        },

        // New Rvp Allocation Changes
        OpenStartTripModal() {
            this.CloseModelStartTrip();
            this.startTripModelFlag = true;
        },
        CloseModelStartTrip() {
            this.Reset();
            this.startTripModelFlag = false;
        },

        /* New Allocation RVP v2 Code Start */
        CommonGetTableDetails() {
            this.CountLoading = true;
            let RVPPayload = {
                "hubId": parseInt(this.userHubId),
                "type": "pending",
                "shipmentType": "RVP",
                "requestedBy":this.createdBy,
                "requestFrom":"WEB"
            }
            if (this.SrId) {
                RVPPayload.srId = this.SrId
            }
            if (this.BucketName) {
                RVPPayload.bucket = this.BucketName
            }
            GetShipmentTableDetails(RVPPayload, async(result) => {
                if (result.data.code == 200) {

                    this.showUnallocatedList = [];

                    // //Pending SR list & count Reset.
                    // this.setSRListAll = this.setSRListP0 = this.setSRListP1 = this.setSRListP2 = [];
                    // this.setSRCountAll = this.setSRCountP0 = this.setSRCountP1 = this.setSRCountP2 = 0;
                    // // Pending SVC list & count Reset.
                    // this.setSVCListAll = this.setSVCListP0 = this.setSVCListP1 = this.setSVCListP2 = [];
                    // this.setSVCCountAll = this.setSVCCountP0 = this.setSVCCountP1 = this.setSVCCountP2 = 0;

                    if (this.setDashboardCountTabNameType == 'pending') {
                        let finalResult = result.data.data;
                        this.setCountSR = finalResult.sr.count;
                        this.setCountSVC = finalResult.svc.count;
                        
                        if (this.SrId || finalResult.sr.list) {
                            this.srBlockFlag = true;
                            this.svcBlockFlag = false;
                            this.activeTabSR = 'primary';
                            this.activeTabSVC = 'outline-primary';
                            
                            /* Updated Code here */
                            await this.updateDynamicType('sr', finalResult);
                            /* Updated Code Here */
                            
                            // this.setSRCountP0 = (finalResult.sr.list && finalResult.sr.list.P0) ? finalResult.sr.list.P0.length : this.setSRCountP0;
                            // this.setSRCountP1 = (finalResult.sr.list && finalResult.sr.list.P1) ? finalResult.sr.list.P1.length : this.setSRCountP1;
                            // this.setSRCountP2 = (finalResult.sr.list && finalResult.sr.list.P2) ? finalResult.sr.list.P2.length : this.setSRCountP2;
                            // this.setSRCountAll = parseInt(this.setSRCountP0) + parseInt(this.setSRCountP1) + parseInt(this.setSRCountP2)
                            //     // this.setSRCountSame_route = (finalResult.sr.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSRCountSame_route;

                            // //Show hide flag
                            // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                            // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                            // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                            // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;
                            // // this.setSRCountSame_routeFlag = (this.setSRCountSame_route > 0) ? true : false;

                            // //SR pending list
                            // if (finalResult.sr.list && finalResult.sr.list.P0) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P0]
                            //     this.setSRListP0 = [...this.setSRListP0, ...finalResult.sr.list.P0]
                            // }
                            // if (finalResult.sr.list && finalResult.sr.list.P1) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P1]
                            //     this.setSRListP1 = [...this.setSRListP1, ...finalResult.sr.list.P1]
                            // }
                            // if (finalResult.sr.list && finalResult.sr.list.P2) {
                            //     this.setSRListAll = [...this.setSRListAll, ...finalResult.sr.list.P2]
                            //     this.setSRListP2 = [...this.setSRListP2, ...finalResult.sr.list.P2]
                            // }
                        } else {
                            // await this.resetPendingData('svc',finalResult)
                            this.srBlockFlag = false;
                            this.svcBlockFlag = true;
                            this.activeTabSVC = 'primary';
                            this.activeTabSR = 'outline-primary';
                            
                            /* Updated Code here */
                            await this.updateDynamicType('svc', finalResult);
                            /* Updated Code Here */
                            
                            // this.setSVCCountP0 = (finalResult.svc.list && finalResult.svc.list.P0) ? finalResult.svc.list.P0.length : this.setSVCCountP0;
                            // this.setSVCCountP1 = (finalResult.svc.list && finalResult.svc.list.P1) ? finalResult.svc.list.P1.length : this.setSVCCountP1;
                            // this.setSVCCountP2 = (finalResult.svc.list && finalResult.svc.list.P2) ? finalResult.svc.list.P2.length : this.setSVCCountP2;
                            // this.setSVCCountAll = parseInt(this.setSVCCountP0) + parseInt(this.setSVCCountP1) + parseInt(this.setSVCCountP2);
                            // // this.setSVCCountSame_route = (finalResult.svc.list.Same_route) ? finalResult.sr.list.Same_route.length : this.setSVCCountSame_route;

                            // //Show hide flag
                            // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                            // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                            // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                            // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                            // // this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                            // //SVC pending List
                            // if (finalResult.svc.list && finalResult.svc.list.P0) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P0]
                            //     this.setSVCListP0 = [...this.setSVCListP0, ...finalResult.svc.list.P0]
                            // }
                            // if (finalResult.svc.list && finalResult.svc.list.P1) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P1]
                            //     this.setSVCListP1 = [...this.setSVCListP1, ...finalResult.svc.list.P1]
                            // }
                            // if (finalResult.svc.list && finalResult.svc.list.P2) {
                            //     this.setSVCListAll = [...this.setSVCListAll, ...finalResult.svc.list.P2]
                            //     this.setSVCListP2 = [...this.setSVCListP2, ...finalResult.svc.list.P2]
                            // }
                        }

                        if (finalResult.svc.list && this.SrId == '') {
                            this.changeSelected('pendingsvc', 'All')
                        } else if (finalResult.sr.list) {
                            this.changeSelected('pendingsr', 'All')
                        } else {
                            this.CountLoading = false;
                        }

                    }
                } else if ([110, 500].includes(result.data.status)) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                    this.$alertify.error(result.data.msg + " Please try again...!");
                } else if (result.data.code != 200) {
                    this.CountLoading = false;
                    this.showUnallocatedList = [];
                    console.log('No Shipments found..');
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }
            })
        },
        async changeSelected(params, subparams) {
            // this.CountLoading = true;
            this.showUnallocatedList = [];
            let upperType = params === 'pendingsr' ? 'SR' : 'SVC';
            if (params == 'pendingsr') {
                this.srBlockFlag = true;
                this.svcBlockFlag = false;
                this.activeTabSR = 'primary';
                this.activeTabSVC = 'outline-primary';

                // ---- Show/Hide SR Count Flags ----
                this.srPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.srPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }

                // //Show hide flag
                // this.setSRCountP0Flag = (this.setSRCountP0 > 0) ? true : false;
                // this.setSRCountP1Flag = (this.setSRCountP1 > 0) ? true : false;
                // this.setSRCountP2Flag = (this.setSRCountP2 > 0) ? true : false;
                // this.setSRCountAllFlag = (this.setSRCountAll > 0) ? true : false;

                // //Show all shipment Pending SR
                // if (subparams == 'All') {
                //     this.activeTabSRAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                //     this.activeTabSRP0Flag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSRP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP1Flag = this.activeTabSRP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSRP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSRListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSRP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                //     this.activeTabSRAllFlag = this.activeTabSRP0Flag = this.activeTabSRP1Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnalllocatedList, this.setSRListP2);
                // }

            } else if (params == 'pendingsvc') {
                this.srBlockFlag = false;
                this.svcBlockFlag = true;
                this.activeTabSVC = 'primary';
                this.activeTabSR = 'outline-primary';

                // ---- Show/Hide Count Flags Dynamically ----
                this.svcPriorities.forEach(key => {
                    this[`set${upperType}Count${key}Flag`] = this[`set${upperType}Count${key}`] > 0;
                });

                // ---- Reset All Active Tab Flags ----
                this.svcPriorities.forEach(key => {
                    this[`activeTab${upperType}${key}Flag`] = 'outline-primary';
                });

                // ---- Determine Selected Tab ----
                const selected = subparams || 'All';
                this[`activeTab${upperType}${selected}Flag`] = 'primary';

                // ---- Merge Corresponding List Dynamically ----
                const listKey = `set${upperType}List${selected}`;
                if (Array.isArray(this[listKey])) {
                    this.showUnallocatedList = [...this.showUnallocatedList, ...this[listKey]];
                }

                // //Show hide flag
                // this.setSVCCountP0Flag = (this.setSVCCountP0 > 0) ? true : false;
                // this.setSVCCountP1Flag = (this.setSVCCountP1 > 0) ? true : false;
                // this.setSVCCountP2Flag = (this.setSVCCountP2 > 0) ? true : false;
                // this.setSVCCountAllFlag = (this.setSVCCountAll > 0) ? true : false;
                // // this.setSVCCountSame_routeFlag = (this.setSVCCountSame_route > 0) ? true : false;

                // //Show all shipment Pending SVC
                // if (subparams == 'All') {
                //     this.activeTabSVCAllFlag = (subparams == 'All') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListAll);
                // } else if (subparams == 'P0') {
                //     this.activeTabSVCP0Flag = (subparams == 'P0') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP1Flag = this.activeTabSVCP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP0);
                // } else if (subparams == 'P1') {
                //     this.activeTabSVCP1Flag = (subparams == 'P1') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP2Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP1);
                // } else if (subparams == 'P2') {
                //     this.activeTabSVCP2Flag = (subparams == 'P2') ? 'primary' : 'outline-primary';
                //     this.activeTabSVCAllFlag = this.activeTabSVCP0Flag = this.activeTabSVCP1Flag = 'outline-primary'
                //     this.showUnallocatedList = [].concat(...this.showUnallocatedList, this.setSVCListP2);
                // }
            }

            if (this.showUnallocatedList.length > 0) {
                    /* Bind new parameter in showUnallocatedList */
                this.showUnallocatedList = this.showUnallocatedList.map(ship => {
                    if (ship) {
                        return Object.assign({}, ship, { srItemObj: {}, SrId: '', SrName: '', OldDeliveryUserOrUserId: '', EmpType: '', CourierCompanyID: '', MobileNumber: '', IsSRNeedTrip: '', selectedUserID: false }); // Use Object.assign to add age
                    }
                    return ship; // Handle undefined or null
                });


                // Create an array of promises
                const promises = this.showUnallocatedList.map(async(obj) => {
                    if (obj.DeliveryUserId !== null && Object.keys(obj.srItemObj).length === 0) {
                        let selectedValue = await this.getUserDetails(obj.DeliveryUserId);
                        if (selectedValue) {
                            obj.srItemObj = selectedValue; // Add new key
                            obj.SrId = selectedValue.value;
                            obj.SrName = selectedValue.text;
                            obj.DeliveryUserName = selectedValue.text;
                            obj.DeliveryUserId = selectedValue.value;
                            obj.OldDeliveryUserOrUserId = selectedValue.OldUserid;
                            obj.EmpType = selectedValue.EmpType;
                            obj.CourierCompanyID = selectedValue.CourierCompanyID;
                            obj.MobileNumber = selectedValue.MobileNumber;
                            obj.IsSRNeedTrip = selectedValue.IsSRNeedTrip;
                            obj.selectedUserID = true;
                            obj.DeliveryUserNameLastAttempted = selectedValue.text;
                        }
                    }
                });
                // Wait for all promises to complete
                await Promise.all(promises);

                if(this.codPendingShipData.length > 0){
                    // Update the main array
                    const promises = this.codPendingShipData.map(async(obj) => {
                        const recordToUpdate = this.showUnallocatedList.find(item => item.ShippingId === obj.ShippingId);
                        if (recordToUpdate) {
                            return Object.assign(recordToUpdate, obj); // Update the matching record
                        }
                        return recordToUpdate;
                    })
                    await Promise.all(promises);
                }

                this.selectedCount = this.showUnallocatedList.filter(obj => obj.selectedUserID == true).length;
                if (this.searchPendingShipment.trim() === '') {
                    this.showUnallocatedListFilter = [...this.showUnallocatedList];
                    this.CountLoading = false;
                }else{
                    this.CountLoading = false;
                    this.filteredTableData();
                }
                }
            this.CountLoading = false;
        },
        // Helper function to get details from srlist by deliveryuserid
        getUserDetails(DeliveryUserId) {
            return this.srList.find(user => user.value === DeliveryUserId.toString()) || null;
        },
        selectAllItems(ev) {
            let FinalFilter = this.searchPendingShipment != "" ? this.showUnallocatedList : this.showUnallocatedListFilter;
            this.selectedItemsOnChild = [];
            if (ev.target.checked == true) {
                for (let i in FinalFilter) {
                    this.selectedItemsOnChild.push(FinalFilter[i]);
                }
            } else {
                for (let i in FinalFilter) {
                    this.selectedItemsOnChild.pop(FinalFilter[i]);
                }
            }

            if (FinalFilter.length <= 1) {
                for (let i in FinalFilter) {
                    this.selectedItemsOnChild.push(FinalFilter[i]);
                }
                for (let i in FinalFilter) {
                    this.selectedItemsOnChild.pop(FinalFilter[i]);
                }
            }
            this.selectedItemdata(ev);
        },
        selectedItemdata($event, row) {
            let FinalFilter = this.searchPendingShipment != "" ? this.showUnallocatedList : this.showUnallocatedListFilter;
            this.outsidesrItemObj = '';
            if ($event.target.checked) {
                row.checker = true;

                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                if (matchingRecords.length > 1) {
                    //Open MPS POPup
                    this.MPSTitle = "Same Address / MPS Shipment";
                    this.MPSSrNameTitle = "";
                    this.MPSNote = `will be selected for the same address and/or MPS shipments.`;
                    this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                    this.MPSCount = `Shipment count: ${matchingRecords.length}`;
                    this.MPSRows = row;
                    this.MPSSelectedRow = "";
                    this.startModelMPS = true; /* Showing MPSGroupID Popup */
                    this.MPSActionType = 'checker';
                    /* END */
                } else {
                    if (this.searchPendingShipment != "") {
                        this.matchingShipmentRecords = [...this.matchingShipmentRecords, ...matchingRecords]
                    }
                }

            } else {
                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                if (matchingRecords.length > 1) {
                    //Open MPS POPup
                    this.MPSTitle = "Same Address / MPS Shipment";
                    this.MPSSrNameTitle = "";
                    this.MPSNote = `will be selected for the same address and/or MPS shipments.`;
                    this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                    this.MPSCount = `Shipment count: ${matchingRecords.length}`;
                    this.MPSRows = row;
                    this.MPSSelectedRow = "";
                    this.startModelMPS = true; /* Showing MPSGroupID Popup */
                    this.MPSActionType = 'checkerRemove';
                    /* END */
                } else {
                    const matchingRecords = matchingShipmentRecords.findIndex(record => record.CustomerAddress === row.CustomerAddress);

                    // If found, remove the shipment from the array
                    if (matchingRecords !== -1) {
                        matchingShipmentRecords.splice(index, 1);
                    }
                    // this.matchingShipmentRecords = this.searchPendingShipment != "" ? matchingRecords : "";
                }
            }
            if (this.selectedItemsOnChild.length == 0) {
                this.selectAllCheckbox = false;
            }
            if (this.selectedItemsOnChild.length <= (FinalFilter.length - 1)) {
                this.selectAllCheckbox = false
            }
            if (this.selectedItemsOnChild.length == FinalFilter.length) {
                this.selectAllCheckbox = true
            }
            if (FinalFilter.length <= 1) {
                this.selectAllCheckbox = true;
                if (this.selectedItemsOnChild.length == 0) {
                    this.selectAllCheckbox = false
                }
            }
        },
        async selectTableSR(selectedValue, row, type) {

            let FinalFilter = this.searchPendingShipment != "" ? this.showUnallocatedList : this.showUnallocatedListFilter;
            if (type == 'Inside') {
                /* Check Selected Value is null or not */
                if (selectedValue.text == "Select SR") {
                    /* Same Address Shipment Logic Start */
                    const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                    //Open MPS POPup
                    if (matchingRecords.length > 1) {
                        this.MPSTitle = "Same Address / MPS Shipment(Remove)";
                        this.MPSSrNameTitle = selectedValue.text;
                        this.MPSNote = `will be selected for the same address and/or MPS shipments.`;
                        this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                        this.MPSCount = `Shipment count: ${matchingRecords.length}`;
                        this.MPSRows = row;
                        this.MPSSelectedRow = selectedValue;
                        this.startModelMPS = true; /* Showing MPSGroupID Popup */
                        this.MPSActionType = 'remove'; /* Showing MPSGroupID Popup */
                    } else {
                        matchingRecords.forEach(obj => {
                            obj.srItemObj = {}; // Add new key
                            obj.SrId = '';
                            obj.SrName = '';
                            obj.OldDeliveryUserOrUserId = '';
                            obj.EmpType = '';
                            obj.CourierCompanyID = '';
                            obj.MobileNumber = '';
                            obj.IsSRNeedTrip = '';
                            obj.selectedUserID = false;
                            obj.DeliveryUserName = '';
                            obj.DeliveryUserId = '';
                        });
                        this.matchingShipmentRecords = this.searchPendingShipment != "" ? "" : "";
                        this.selectedCount = FinalFilter.filter(obj => obj.selectedUserID == true).length;
                    }
                    /* END */

                } else {
                    row.EmpType = selectedValue.EmpType;
                    let validationResult = await this.validateEODAllocationBulk(selectedValue, row);
                    if (validationResult) {
                        if (row.EmpType == null || row.EmpType == "") {
                            this.$alertify.error("EmpType not found against this SR, EmpType is required.");
                        } else {
                            /* Same Address Shipment Logic Start */
                            const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress).length;
                            //Open MPS POPup
                            if (matchingRecords > 1) {
                                this.MPSTitle = "Same Address / MPS Shipment";
                                this.MPSSrNameTitle = selectedValue.text;
                                this.MPSNote = `will be selected for the same address and/or MPS shipments.`;
                                this.MPSAddress = `Address:- ${row.CustomerAddress}.`;
                                this.MPSCount = `Shipment count: ${matchingRecords}`;
                                this.MPSRows = row;
                                this.MPSSelectedRow = selectedValue;
                                this.startModelMPS = true; /* Showing MPSGroupID Popup */
                                this.MPSActionType = 'Add';
                            } else {
                                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress)
                                matchingRecords.forEach(obj => {
                                    obj.srItemObj = selectedValue; // Add new key
                                    obj.SrId = selectedValue.value;
                                    obj.SrName = selectedValue.text;
                                    obj.DeliveryUserName = selectedValue.text;
                                    obj.DeliveryUserId = selectedValue.value;
                                    obj.OldDeliveryUserOrUserId = selectedValue.OldUserid;
                                    obj.EmpType = selectedValue.EmpType;
                                    obj.CourierCompanyID = selectedValue.CourierCompanyID;
                                    obj.MobileNumber = selectedValue.MobileNumber;
                                    obj.IsSRNeedTrip = selectedValue.IsSRNeedTrip;
                                    obj.selectedUserID = true;
                                });
                            }
                            this.selectedCount = FinalFilter.filter(obj => obj.selectedUserID == true).length;
                            /* END */
                        }
                    }
                }
            } else {
                if (selectedValue.text == "Select SR") {
                    this.outsidesrItemObj = selectedValue;
                    this.outsideSrId = selectedValue.value;
                    FinalFilter.forEach(obj => {
                        // Check if shippingId in mainArray matches any in matchArray
                        const matchIndex = this.selectedItemsOnChild.findIndex(match => match.ShippingID === obj.ShippingID.toString());
                        if (matchIndex !== -1) {
                            // If a match is found, set checker to true
                            obj.checker = false;
                            obj.srItemObj = {}; // Add new key
                            obj.SrId = '';
                            obj.SrName = '';
                            obj.OldDeliveryUserOrUserId = '';
                            obj.EmpType = '';
                            obj.CourierCompanyID = '';
                            obj.MobileNumber = '';
                            obj.IsSRNeedTrip = '';
                            obj.selectedUserID = false;
                            obj.DeliveryUserName = '';
                            obj.DeliveryUserId = '';
                        }
                    });
                } else {

                    let validationResult = await this.validateEODAllocationBulk(selectedValue, row);
                    if (validationResult) {
                        if (selectedValue.EmpType == null || selectedValue.EmpType == "") {
                            this.$alertify.error("EmpType not found against this SR, EmpType is required.");
                        } else {
                            this.outsidesrItemObj = selectedValue;
                            this.outsideSrId = selectedValue.value;
                            FinalFilter.forEach(obj => {
                                // Check if shippingId in mainArray matches any in matchArray
                                const matchIndex = this.selectedItemsOnChild.findIndex(match => match.ShippingID === obj.ShippingID.toString());
                                if (matchIndex !== -1) {
                                    // If a match is found, set checker to true
                                    obj.checker = true;
                                    obj.srItemObj = selectedValue; // Add new key
                                    obj.SrId = selectedValue.value;
                                    obj.SrName = selectedValue.text;
                                    obj.DeliveryUserName = selectedValue.text;
                                    obj.DeliveryUserId = selectedValue.value;
                                    obj.OldDeliveryUserOrUserId = selectedValue.OldUserid;
                                    obj.EmpType = selectedValue.EmpType;
                                    obj.CourierCompanyID = selectedValue.CourierCompanyID;
                                    obj.MobileNumber = selectedValue.MobileNumber;
                                    obj.IsSRNeedTrip = selectedValue.IsSRNeedTrip;
                                    obj.selectedUserID = true;
                                    // Remove the matched obj from matchArray
                                    this.selectedItemsOnChild.splice(matchIndex, 1);
                                }
                            });
                            this.selectAllCheckbox = false;
                            this.selectedCount = FinalFilter.filter(obj => obj.selectedUserID == true).length;
                        }
                    }
                }
            }
            this.syncUpdatedRecords(this.showUnallocatedListFilter, this.showUnallocatedList);
        },
        FilterselectSR(obj) {
            this.SrId = obj.value;
            this.srItemObj = obj;
            this.searchPendingShipment = "";
            if(!obj.ishvonboardingdone || !obj.isselfieverified){
                let hyperVFailureMsg = !obj.ishvonboardingdone ? this.hvOnboardingFailMsg : this.hvSelieFailMsg;
                this.hideAllocateFlag = false;
                this.startTripFlag = false;
                return this.$alertify.error(hyperVFailureMsg);
            }

            this.CommonGetTableDetails()
        },
        FilterFacility() {
            this.SrId = '';
            this.srItemObj = '';
            this.CommonGetTableDetails()
        },
        getSameMPSGroupShipmentsRVP2(selectedValue, row, type) {
            let FinalFilter = this.searchPendingShipment != "" ? this.showUnallocatedList : this.showUnallocatedListFilter;
            if (type == 'Add') {
                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.srItemObj = selectedValue; // Add new key
                    obj.SrId = selectedValue.value;
                    obj.SrName = selectedValue.text;
                    obj.DeliveryUserName = selectedValue.text;
                    obj.DeliveryUserId = selectedValue.value;
                    obj.OldDeliveryUserOrUserId = selectedValue.OldUserid;
                    obj.EmpType = selectedValue.EmpType;
                    obj.CourierCompanyID = selectedValue.CourierCompanyID;
                    obj.MobileNumber = selectedValue.MobileNumber;
                    obj.IsSRNeedTrip = selectedValue.IsSRNeedTrip;
                    obj.selectedUserID = true;
                });
                if(this.searchPendingShipment != ""){
                    this.matchingShipmentRecords = [...this.matchingShipmentRecords,...matchingRecords]
                }
                
                this.selectedCount = FinalFilter.filter(obj => obj.selectedUserID == true).length;
            } else if (type == 'remove') {
                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.srItemObj = {}; // Add new key
                    obj.SrId = '';
                    obj.SrName = '';
                    obj.OldDeliveryUserOrUserId = '';
                    obj.EmpType = '';
                    obj.CourierCompanyID = '';
                    obj.MobileNumber = '';
                    obj.IsSRNeedTrip = '';
                    obj.selectedUserID = false;
                    obj.DeliveryUserName = '';
                    obj.DeliveryUserId = '';
                    
                });
                // Remove elements from finalArray that are in tempArray
                if(this.searchPendingShipment != ""){
                    this.matchingShipmentRecords = this.matchingShipmentRecords.filter(item => !matchingRecords.includes(item));
                }
                this.selectedCount = FinalFilter.filter(obj => obj.selectedUserID == true).length;
            } else if (type == 'checker') {
                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.checker = true;
                    const exists = this.selectedItemsOnChild.some(item => item.ShippingID === obj.ShippingID.toString());

                    // If not exists, push the object into the final array
                    if (!exists) {
                        this.selectedItemsOnChild.push(obj);
                    }
                });
                if(this.searchPendingShipment != "" ){
                    this.matchingShipmentRecords = [...this.matchingShipmentRecords,...matchingRecords]
                }
            } else if (type == 'checkerRemove') {
                const matchingRecords = FinalFilter.filter(record => record.CustomerAddress === row.CustomerAddress);
                //Add new param for Select box
                // Add a new key-value to each matching record
                matchingRecords.forEach(obj => {
                    obj.checker = false; // Add a new param to each matching record

                    // Find the index of the matching record in selectedItemsOnChild
                    const index = this.selectedItemsOnChild.findIndex(
                        item => item.ShippingID === obj.ShippingID.toString()
                    );

                    // If found, remove the object from the selectedItemsOnChild array
                    if (index !== -1) {
                        this.selectedItemsOnChild.splice(index, 1);
                    }
                });
                if(this.searchPendingShipment != ""){
                    this.matchingShipmentRecords = this.matchingShipmentRecords.filter(item => !matchingRecords.includes(item));
                }
            }
            this.syncUpdatedRecords(this.showUnallocatedListFilter, this.showUnallocatedList);
            this.CloseModelMPS();
        },
        CloseModelMPS(selectedValue, row, type) {

            if (type == 'checker') {
                this.selectedItemsOnChild.pop(row);
            }
            if (type == 'checkerRemove') {
                this.selectedItemsOnChild.push(row);
            }
            this.MPSTitle = "";
            this.MPSSrNameTitle = "";
            this.MPSNote = "";
            this.MPSRows = "";
            this.MPSSelectedRow = "";
            this.startModelMPS = false;
            this.MPSAddress = '';
            this.MPSCount = '';
            this.MPSActionType = '';
        },
        validateEODAllocationBulk(selectedValue, row) {
            return new Promise((resolve, reject) => {
                let EODvalidationdata = {
                    "DeliveryUserID": selectedValue.value,
                    "HubID": this.userHubId
                }

                EODValidation(EODvalidationdata, (result) => {
                    if (result.data.code === 202) {
                        this.$alertify.error(result.data.message);
                        resolve(false);
                    } else {
                        this.PassEOD = true
                        resolve(true);
                    }
                    this.TopReset = false
                })
            });
        },
        async allocatePickupShipment() {
            try {
                this.$emit("start-loading")  // Tell parent to show loader
                this.UASelectedArr = [];
                this.CountLoading = true;
                // this.IsReload = true;
                //let validateUser = await this.validateJwtToken()
                // Filter the array to get only the records with selected: true
                // let blockStatus = await this.checkScantallyBatchClosedOrNot(this.userHubId);
                // if (blockStatus) {
                //     return false
                // }

                // let TripStatus = await this.checkTripStatus();
                console.log("----Start Allocation ----"+this.bindShipmentForAllocation.length+"-----");
                
                if(this.EBNshippingData.length > 0){
                    this.bindShipmentForAllocation;
                    console.log("----EBNshippingData ----"+this.bindShipmentForAllocation.length+"-----");

                }
                else if (this.matchingShipmentRecords != "") {
                    this.bindShipmentForAllocation = this.matchingShipmentRecords.filter(item => item.selectedUserID);
                    console.log("----matchingShipmentRecords ----"+this.bindShipmentForAllocation.length+"-----");

                } else if (this.selectedItemsOnChild.length > 0) {
                    this.bindShipmentForAllocation = this.showUnallocatedListFilter.filter(item => item.checker == true);
                    console.log("----selectedItemsOnChild ----"+this.bindShipmentForAllocation.length+"-----");

                } else {
                    if (this.showUnallocatedListFilter.filter(item => item.selectedUserID).length == 1 && this.searchPendingShipment != "") {
                        let row = this.showUnallocatedListFilter.filter(item => item.selectedUserID);

                        const matchingRecords = this.showUnallocatedList.filter(record => record.CustomerAddress === row[0].CustomerAddress);
                        //Add new param for Select box
                        // Add a new key-value to each matching record
                        matchingRecords.forEach(obj => {
                            obj.srItemObj = row[0].srItemObj; // Add new key
                            obj.SrId = row[0].srItemObj.value;
                            obj.SrName = row[0].srItemObj.text;
                            obj.DeliveryUserName = row[0].srItemObj.text;
                            obj.DeliveryUserId = row[0].srItemObj.value;
                            obj.OldDeliveryUserOrUserId = row[0].srItemObj.OldUserid;
                            obj.EmpType = row[0].srItemObj.EmpType;
                            obj.CourierCompanyID = row[0].srItemObj.CourierCompanyID;
                            obj.MobileNumber = row[0].srItemObj.MobileNumber;
                            obj.IsSRNeedTrip = row[0].srItemObj.IsSRNeedTrip;
                            obj.selectedUserID = true;
                        });
                        this.singlematchingShipmentRecords = this.searchPendingShipment != "" ? matchingRecords : "";                        
                        this.bindShipmentForAllocation = this.singlematchingShipmentRecords.filter(item => item.selectedUserID);
                        console.log("----searchPendingShipment singlematchingShipmentRecords ----"+this.bindShipmentForAllocation.length+"-----");

                    } else {
                        this.bindShipmentForAllocation = this.showUnallocatedListFilter.filter(item => item.selectedUserID);
                        console.log("----without Search ----"+this.bindShipmentForAllocation.length+"-----");
                    }
                }

                this.bindShipmentForAllocation = await this.checkHyperVergeValidation(this.bindShipmentForAllocation);
                console.log("----checkHyperVergeValidation ----"+this.bindShipmentForAllocation.length+"-----");
                if(this.hvValidationFailedData.length > 0){
                    this.$emit("stop-loading")   // Tell parent to hide loader
                    const isDialogConfirmed = await this.showHVValidationDialog();
                    if (!isDialogConfirmed) {
                        this.CountLoading = false;
                        return;
                    } else {
                        this.$emit("start-loading")
                    }
                }

                this.DeliveryUserIDs = [];
                let tripStatus = await this.checktripstartOrNot(this.bindShipmentForAllocation);
                if (tripStatus) {
                    this.$emit("stop-loading")   // Tell parent to hide loader
                    this.CountLoading = false;
                    this.startTripModelFlag = true;
                    return false
                }

                //SR COD Pending Amount check
                this.bindShipmentForAllocation = await this.checkCODPendingOrNot(this.bindShipmentForAllocation);
                console.log("----checkCODPendingOrNot ----"+this.bindShipmentForAllocation.length+"-----");
                if(this.codPendingUserData.length > 0){
                    this.$emit("stop-loading")   // Tell parent to hide loader
                    const isDialogConfirmed = await this.showCodPendingDialog();
                    if (!isDialogConfirmed) {
                        this.CountLoading = false;
                        return;
                    }
                }

                if(this.bindShipmentForAllocation.length > 0){
                    console.log("----Final Shipment For Allocation ----"+this.bindShipmentForAllocation.length+"-----");
                    this.UASelectedArr = this.UASelectedArr.concat(this.bindShipmentForAllocation)
                    var self = this;
                    this.errorRvpAllocation = "";
                    this.successRvpAllocation = '';
                    this.errorRvpAllocationErrorArrobj = [];
                    this.ShipmentFutureFailedArrObj = [];
                    this.ShipmentFailedArrObj = [];
                    this.EBNshippingData = []
                    if (this.UASelectedArr.length > 0) {
                        this.resArray = [];
                        var successCount = 0;
                        var failCount = 0;
                        var failCountFutureDate = 0;
                        var failShipmentsFDArray = [];
                        var failShipmentsArray = [];
                        let tempEbnShipments = [];
                        // let chain = Promise.resolve();
                        /* Add Promis Here */
                        // let promiseArr = [];
                        // for (let val of this.UASelectedArr) {
                        //     // chain = chain.then(() => self.bulkAllocationForRVP2(val));
                        //     promiseArr.push(self.bulkAllocationForRVP2(val));
                        // }
                        // Promise.all(promiseArr).then(Success => {
                            this.processBatchWiseAllocation(20,this.UASelectedArr).then(allResults => {

                            this.$emit("stop-loading")   // Tell parent to hide loader
                            var result = this.resArray
                            this.vehiclePopup = false;

                            for (var i = 0; i < result.length; i++) {
                                if (result[i].statusCode == 206) {
                                    failShipmentsFDArray.push(result[i].shippingId)
                                    failCountFutureDate++;
                                    this.ShipmentFutureFailedArrObj.push(result[i]);
                                } else if (result[i].statusCode == 207) {
                                    this.EBNshippingData.push({ shippingId: result[i].shippingId })
                                    let filteredEBNshipObj = this.bindShipmentForAllocation.filter(item => item.ShippingID == result[i].shippingId);
                                    tempEbnShipments = [...tempEbnShipments, ...filteredEBNshipObj]
                                } else if (result[i].statusCode == 200) {
                                    successCount++;
                                    if (result[i].prexoShipment) {
                                        this.rvpPrexoShipmentList.push(parseInt(result[i].prexoShipment));
                                    }
                                } else {
                                    if(typeof result[i].message === "string" && result[i].message.startsWith("Shipment is already allocated to DeliveryUserID")){
                                        successCount++;
                                    } else {
                                        failCount++;
                                        this.ShipmentFailedArrObj.push(result[i]);
                                    }
                                }
                            }
                            if (failCount > 0) {
                                this.dismissCountDown = 10
                                self.errorRvpAllocation = failCount + " shipping ids cannot assign for pickup."
                                this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
                            }
                            if (failCountFutureDate > 0) {
                                this.dismissCountDown = 10
                                self.errorRvpAllocation = failCountFutureDate + " these shipping ids cannot assign for pickup, because pickup date set as a future date.";
                                this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
                            }
                            if (successCount > 0) {
                                this.dismissCountDownSuccess = 10;
                                self.successRvpAllocation = successCount + " shipments allocated successfully";
                            }

                            // this.IsReload = false;
                            this.ebnDataLoader = false
                            this.rvpAddress = ''
                            this.isLoadingASL = false;
                            this.bindShipmentForAllocation = [];
                            if (this.EBNshippingData.length > 0) {
                                this.$emit("stop-loading")   // Tell parent to hide loader
                                this.CountLoading = false;
                                this.morePendingRVPShipmentsModel = false
                                this.vehiclePopup = true
                                this.isActiveRvp = false
                                    // console.log("----------tempEbnShipments----------------" + JSON.stringify(tempEbnShipments));
                                this.bindShipmentForAllocation = tempEbnShipments
                                    // this.UASelectedArr = tempEbnShipments
                                return true
                            }
                            this.$emit("stop-loading")   // Tell parent to hide loader
                            // this.AllocatedFwdShipmentData();
                            //this.loadAllocatedShipmentListInHub();
                            //this.loadUnallocatedShipmentsList();
                            //this.GetCount();
                            this.isAllocationRvp = true;
                            this.morePendingRVPShipmentsModel = false
                            this.isActiveRvp = false
                            this.CountLoading = false;
                            EventBus.$emit('refreshSecondPanel');
                            this.clearallocationFields();
                            this.closevehiclePopup();
                        }).catch(err => {
                            console.log('promise Error', err);
                            self.errorRvpAllocation = err.message;
                            this.$emit("stop-loading")   // Tell parent to hide loader
                        });


                        // chain.then(() => {
                        //     this.$emit("stop-loading")   // Tell parent to hide loader
                        //     var result = this.resArray
                        //     this.vehiclePopup = false;

                        //     for (var i = 0; i < result.length; i++) {
                        //         if (result[i].statusCode == 206) {
                        //             failShipmentsFDArray.push(result[i].shippingId)
                        //             failCountFutureDate++;
                        //             this.ShipmentFutureFailedArrObj.push(result[i]);
                        //         } else if (result[i].statusCode == 207) {
                        //             this.EBNshippingData.push({ shippingId: result[i].shippingId })
                        //             let filteredEBNshipObj = this.bindShipmentForAllocation.filter(item => item.ShippingID == result[i].shippingId);
                        //             tempEbnShipments = [...tempEbnShipments, ...filteredEBNshipObj]
                        //         } else if (result[i].statusCode == 200) {
                        //             successCount++;
                        //             if (result[i].prexoShipment) {
                        //                 this.rvpPrexoShipmentList.push(parseInt(result[i].prexoShipment));
                        //             }
                        //         } else {
                        //             failCount++;
                        //             this.ShipmentFailedArrObj.push(result[i]);
                        //         }
                        //     }
                        //     if (failCount > 0) {
                        //         this.dismissCountDown = 10
                        //         self.errorRvpAllocation = failCount + " shipping ids cannot assign for pickup."
                        //         this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
                        //     }
                        //     if (failCountFutureDate > 0) {
                        //         this.dismissCountDown = 10
                        //         self.errorRvpAllocation = failCountFutureDate + " these shipping ids cannot assign for pickup, because pickup date set as a future date.";
                        //         this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
                        //     }
                        //     if (successCount > 0) {
                        //         this.dismissCountDownSuccess = 10;
                        //         self.successRvpAllocation = successCount + " shipments allocated successfully";
                        //     }

                        //     // this.IsReload = false;
                        //     this.ebnDataLoader = false
                        //     this.rvpAddress = ''
                        //     this.isLoadingASL = false;
                        //     this.bindShipmentForAllocation = [];
                        //     if (this.EBNshippingData.length > 0) {
                        //         this.$emit("stop-loading")   // Tell parent to hide loader
                        //         this.CountLoading = false;
                        //         this.morePendingRVPShipmentsModel = false
                        //         this.vehiclePopup = true
                        //         this.isActiveRvp = false
                        //             // console.log("----------tempEbnShipments----------------" + JSON.stringify(tempEbnShipments));
                        //         this.bindShipmentForAllocation = tempEbnShipments
                        //             // this.UASelectedArr = tempEbnShipments
                        //         return true
                        //     }
                        //     this.$emit("stop-loading")   // Tell parent to hide loader
                        //     // this.AllocatedFwdShipmentData();
                        //     //this.loadAllocatedShipmentListInHub();
                        //     //this.loadUnallocatedShipmentsList();
                        //     //this.GetCount();
                        //     this.isAllocationRvp = true;
                        //     this.morePendingRVPShipmentsModel = false
                        //     this.isActiveRvp = false
                        //     this.CountLoading = false;
                        //     EventBus.$emit('referseFirstPanel');
                        //     this.clearallocationFields();
                        //     this.closevehiclePopup();
                        // }).catch(err => {
                        //     console.log('promise Error', err);
                        //     self.errorRvpAllocation = err.message;
                        //     this.$emit("stop-loading")   // Tell parent to hide loader
                        // });
                    }
                }else{
                    this.CountLoading = false;
                    return false;
                }               
            } catch (e) {
                console.log('Error in allocation page', e);
            }
        },
        bulkAllocationForRVP2(shipDetails) {
            // console.log("---shipDetails---" + JSON.stringify(shipDetails));

            try {
                // this.IsReload = true;
                return new Promise((resolve, reject) => {
                    this.files = []
                        // var selectedSrDtl = this.srArrayList.filter(n => {
                        //     return n.userid == this.SrId
                        // })

                    this.input = {
                            "isAllocationFrom": 'New',
                            "XBkey": "XB123",
                            "HubId": this.userHubId.toString(),
                            "DeliveryUserId": shipDetails.SrId,
                            "OldDeliveryUserOrUserId": shipDetails.OldDeliveryUserOrUserId ? shipDetails.OldDeliveryUserOrUserId.toString() : "0",
                            "DeliveryUserName": shipDetails.SrName,
                            "ShippingID": shipDetails.ShippingID,
                            "LastModifiedBy": this.createdBy,
                            "IsConfirmAllocation": false,
                            "AllocationType": 'RVP',
                            "EmpType": shipDetails.EmpType ? shipDetails.EmpType : "",
                            "MarkedFrom": "Web",
                            "CourierCompanyID": shipDetails.CourierCompanyID ? shipDetails.CourierCompanyID.toString() : 'null',
                            "IsRSVCSr": this.isRSVSr,
                            "MobileNo": shipDetails.MobileNumber ? shipDetails.MobileNumber.toString() : "",
                            "isTripAllowedForSR": shipDetails.IsSRNeedTrip,
                            "IsRVPPaperless": this.IsRVPPaperless,
                            "vehicleno": this.vehiclePopup ? this.vehicleNumbers[shipDetails.ShippingID] : undefined
                        }
                        // console.log("------------------------In----------------" + JSON.stringify(this.input));


                    AllocateShipment(this.input, (result) => {
                        var result = result.data
                            //Hundle Prexo shipment error and succes msg
                        let finalObjOfErrorOrSuccess = { "success": false, "statusCode": result.status, "message": result.message, "shippingId": shipDetails.ShippingID }
                        if (result.status == 204) {
                            this.resArray.push(finalObjOfErrorOrSuccess);
                            resolve({ "success": false, "statusCode": result.status, "message": result.message, "shippingId": shipDetails.ShippingID });
                        } else if (result.status == 206) {
                            this.resArray.push(finalObjOfErrorOrSuccess)
                            resolve();
                        } else if (result.status == 207) {
                            //ebn condition.
                            this.resArray.push(finalObjOfErrorOrSuccess);
                            resolve();
                        } else if (result.status == 110) {
                            //ebn condition.
                            resolve({"statusCode":result.status,'retry':shipDetails});
                        } else if (result.code == 200) {
                            // $("#rvpTr"+shippingId).remove();
                            let TrackerInfo = {
                                projectname: "Last Mile",
                                type: "Web",
                                userid: this.userid,
                                username: this.createdBy,
                                meta: {
                                    "event": "bulkAllocation",
                                    "HubId": this.userHubId.toString(),
                                    "DeliveryUserId": this.SrId,
                                    "ShippingID": shipDetails.ShippingID.toString()
                                }
                            }
                            this.PageTracker(TrackerInfo);
                            for (var i = 0; i < this.UASelectedArr.length; i++) {
                                if (this.UASelectedArr[i] == shipDetails.ShippingID) {
                                    this.UASelectedArr.splice(i, 1);
                                }
                            }
                            this.isAllocation = true
                            finalObjOfErrorOrSuccess.success = true;
                            finalObjOfErrorOrSuccess.statusCode = result.code;
                            this.resArray.push(finalObjOfErrorOrSuccess)
                            resolve();
                        } else {
                            finalObjOfErrorOrSuccess.statusCode = result.code;
                            this.resArray.push(finalObjOfErrorOrSuccess)
                            resolve();
                        }
                        // this.IsReload = false;

                    }).catch((err)=>{
                        resolve({"statusCode":110,'retry':shipDetails});
                    })
                })
            } catch (e) {
                console.log('Exit error', e);
            }
        },
        shipmentInfo() {
            this.shipmentInfoFlag = true
        },
        CloseshipmentInfoFlag() {
            this.shipmentInfoFlag = false
        },
        checkScantallyBatchClosedOrNot(hubid = 0, CourierCompanyID = 0) {
            return new Promise((resolve, reject) => {
                let Payload = {
                    "HubId": hubid.toString(),
                    "CourierCompanyID": CourierCompanyID
                }
                ScanTallyBatchStatus(Payload, (result) => {
                    if (result.data.code == 200) {
                        // this.$alertify.success(result.data.message)
                        this.isScantallyBatchOpenFlag = false;
                        resolve(false)
                    } else {
                        this.srItemObj = { value: "", text: "" }
                        this.srName = '';
                        this.srId = '';
                        this.isScantallyBatchOpenFlag = true;
                        resolve(true)
                        this.$alertify.error(result.data.message)
                    }
                })
            });
        },
        RefreshShipment() {
            this.Reset()
        },
        checktripstartOrNot(bindShipmentForAllocation) {
            return new Promise(async(resolve, reject) => {
                let ProcessedDeliveryUserIdsArr = [];
                for (let index = 0; index < bindShipmentForAllocation.length; index++) {
                    const element = bindShipmentForAllocation[index];
                    let selectedValue = await this.getUserDetails(element.DeliveryUserId);
                    if (selectedValue) {
                        if(!ProcessedDeliveryUserIdsArr.includes(selectedValue.text)){
                            if (selectedValue.value && !this.DeliveryUserIDs.includes(selectedValue.text) && selectedValue.IsSRNeedTrip) {
                                let DeliUID = await this.getSrTripdetails(selectedValue.value);

                                if (DeliUID) {
                                    this.DeliveryUserIDs.push(selectedValue.text)
                                }else{
                                    ProcessedDeliveryUserIdsArr.push(selectedValue.text)
                                }
                            }
                        }
                    }

                }
                if (this.DeliveryUserIDs.length > 0) {
                    resolve(true)
                } else {
                    resolve(false)
                }
            });
        },
        getSrTripdetails(SrId) {
            return new Promise((resolve, reject) => {
                let TripDetailsRVPPayload = {
                    "XBkey": "XB123",
                    "HubId": this.userHubId,
                    "DeliveryUserId": SrId
                }
                GetTripdetails(TripDetailsRVPPayload, (result) => {
                    if (result.data.TripState == "created" || result.data.TripState == "start") {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                }, error => {
                    console.error(error)
                })
            })
        },
        handleSelectClick(rowindex) {
            this.selectedRow = rowindex;
        },
        syncUpdatedRecords(array1,array2){

            array1.forEach(item1 => {
                // ---- Step 1: Sync array2 base list ----
                let index = array2.findIndex(item2 => item2.ShippingID === item1.ShippingID);
                if (index !== -1 && JSON.stringify(array2[index]) !== JSON.stringify(item1)) {
                    array2[index] = Object.assign({}, item1);
                }

                // ---- Step 2: Dynamic update for each type (SVC, SR) ----
                let types = ['SVC', 'SR'];

                types.forEach(type => {
                    let lowerType = type.toLowerCase();
                    let priorities = this[`${lowerType}Priorities`];
                    console.log("---priorities----"+priorities);
                    
                    if(priorities){
                        priorities.forEach(priority => {
                            let listKey = `set${type}List${priority}`;
                            let list = this[listKey];
                            if (Array.isArray(list)) {
                                let idx = list.findIndex(i => i.ShippingID === item1.ShippingID);
                                if (idx !== -1 && JSON.stringify(list[idx]) !== JSON.stringify(item1)) {
                                    this[listKey][idx] = Object.assign({}, item1);
                                }
                            }
                        });
                    }
                    
                });
            });


            // array1.forEach(item1 => {
            //     let index = array2.findIndex(item2 => item2.ShippingID === item1.ShippingID);
            
            //     if (index !== -1 && JSON.stringify(array2[index]) !== JSON.stringify(item1)) {
            //       // Update the record in array2 if it differs from array1
            //       array2[index] = Object.assign({}, item1);
            //     }

            //     //SVC P0
            //     let indexsvcp0 = this.setSVCListP0.findIndex(item2svcp0 => item2svcp0.ShippingID === item1.ShippingID);
            
            //     if (indexsvcp0 !== -1 && JSON.stringify(this.setSVCListP0[indexsvcp0]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSVCListP0[indexsvcp0] = Object.assign({}, item1);
            //     }

            //     //SVC p1
            //     let indexsvcp1 = this.setSVCListP1.findIndex(item2svcp1 => item2svcp1.ShippingID === item1.ShippingID);
            
            //     if (indexsvcp1 !== -1 && JSON.stringify(this.setSVCListP1[indexsvcp1]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSVCListP1[indexsvcp1] = Object.assign({}, item1);
            //     }

            //     //SVC p2
            //     let indexsvcp2 = this.setSVCListP2.findIndex(item2svcp2 => item2svcp2.ShippingID === item1.ShippingID);
            
            //     if (indexsvcp2 !== -1 && JSON.stringify(this.setSVCListP2[indexsvcp2]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSVCListP2[indexsvcp2] = Object.assign({}, item1);
            //     }

            //     //SVC All
            //     let indexsvcall = this.setSVCListAll.findIndex(item2svcall => item2svcall.ShippingID === item1.ShippingID);
            
            //     if (indexsvcall !== -1 && JSON.stringify(this.setSVCListAll[indexsvcall]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSVCListAll[indexsvcall] = Object.assign({}, item1);
            //     }

            //     /* SR */
                
            //     //SR P0
            //     let indexsrp0 = this.setSRListP0.findIndex(item2srp0 => item2srp0.ShippingID === item1.ShippingID);
            
            //     if (indexsrp0 !== -1 && JSON.stringify(this.setSRListP0[indexsrp0]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSRListP0[indexsrp0] = Object.assign({}, item1);
            //     }

            //     //SR p1
            //     let indexsrp1 = this.setSRListP1.findIndex(item2srp1 => item2srp1.ShippingID === item1.ShippingID);
            
            //     if (indexsrp1 !== -1 && JSON.stringify(this.setSRListP1[indexsrp1]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSRListP1[indexsrp1] = Object.assign({}, item1);
            //     }

            //     //SR p2
            //     let indexsrp2 = this.setSRListP2.findIndex(item2srp2 => item2srp2.ShippingID === item1.ShippingID);
            
            //     if (indexsrp2 !== -1 && JSON.stringify(this.setSRListP2[indexsrp2]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSRListP2[indexsrp2] = Object.assign({}, item1);
            //     }

            //     //SR All
            //     let indexsrall = this.setSRListAll.findIndex(item2srall => item2srall.ShippingID === item1.ShippingID);
            
            //     if (indexsrall !== -1 && JSON.stringify(this.setSRListAll[indexsrall]) !== JSON.stringify(item1)) {
            //       // Update the record in this. if it differs from array1
            //       this.setSRListAll[indexsrall] = Object.assign({}, item1);
            //     }
            //   });
        },
        shouldShow(row) {
            if(['P0','P1'].includes(row.Bucket)){
                return row.DeliveryUserNameLastAttempted && Object.keys(row.srItemObj).length === 0;
            }
        },

        checkCODPendingOrNot(shipsData){
            return new Promise(async (resolve, reject) => {
                //Push SRIds in single Array
                const userIdsArr = [];
                let codApiRes = [];
                shipsData.forEach(shipment => {
                    if (!userIdsArr.includes(shipment.DeliveryUserId)) {
                        userIdsArr.push(shipment.DeliveryUserId);
                    }
                });
                // Divide user IDs data into batches of 25
                const userBatches = this.divideIntoBatches(userIdsArr, 25);

                for (let i = 0; i < userBatches.length; i++) {
                    const userIdsBatch = userBatches[i];
                    const payload = {
                        "srIds": userIdsBatch
                    }

                    await getUserCodDetails(payload, (result) => {
                        if (result.data.code == 200) {
                            codApiRes = [...codApiRes, ...result.data.data];
                        }
                    }, error => {
                        console.error(error)
                    })
                }

                let dummyShipData = [];
                this.codPendingShipData = [];
                this.codPendingUserData = [];
                for(let shipment of shipsData){
                    let userDetail = await this.getSRCODDetails(shipment.DeliveryUserId, codApiRes);
                    if(this.IsPendingCODBlock && this.hubCODPendingLimit != null){
                        if(userDetail && !userDetail.IsDayAllocationDone && userDetail.pendingAmount && userDetail.pendingAmount > this.hubCODPendingLimit){
                            dummyShipData.push(shipment.DeliveryUserId);
                            this.codPendingShipData.push(shipment);
                            if (!this.codPendingUserData.some(item => item.srId === userDetail.srId)) {
                                userDetail.userName = shipment.DeliveryUserName;
                                this.codPendingUserData.push(userDetail);
                            }
                        }
                    }
                }

                shipsData = shipsData.filter(item => !dummyShipData.includes(item.DeliveryUserId));
                return resolve(shipsData);
            })
        },

        // Function to divide an array into batches of a given size
        divideIntoBatches(array, batchSize) {
            const batches = [];
            for (let i = 0; i < array.length; i += batchSize) {
                batches.push(array.slice(i, i + batchSize));
            }
            return batches;
        },

        getSRCODDetails(DeliveryUserId, result) {
            return result.find(user => user.srId.toString() === DeliveryUserId.toString());
        },

        showCodPendingDialog(){
            return new Promise((resolve) => {
                // Dynamically create table rows from the codPendingShipData array
                const tableRows = this.codPendingUserData.map((user) => `
                    <tr>
                    <td style="padding: 8px; border-bottom: 1px solid #ddd;border-right: 1px solid #ddd; border-left: 1px solid #ddd">${user.userName}</td>
                    <td style="padding: 8px; border-bottom: 1px solid #ddd;border-right: 1px solid #ddd; border-left: 1px solid #ddd">${user.pendingAmount}</td>
                    </tr>`
                ).join('');
                
                const message = `
                    <div style="max-height: 400px; overflow-y: auto; padding: 10px;">
                    <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px; color: red">
                        Please clear the pending COD Amount against the below users before allocation and try again:
                    </p>
                    <p style="border-bottom: 1px solid #ddd; padding: 8px;border-right: 1px solid #ddd; border-left: 1px solid #ddd;border-top: 1px solid #ddd">
                        Pending Amount Limit: ${this.hubCODPendingLimit} </p>
                    <table style="width: 100%; border-collapse: collapse; text-align: left;">
                        <thead>
                        <tr>
                            <th style="border-bottom: 1px solid #ddd; padding: 8px;border-right: 1px solid #ddd; border-left: 1px solid #ddd;border-top: 1px solid #ddd">Username</th>
                            <th style="border-bottom: 1px solid #ddd; padding: 8px;border-right: 1px solid #ddd; border-left: 1px solid #ddd;border-top: 1px solid #ddd">Pending Amount on SR</th>
                        </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                    </div>
                `;
                
                this.$dialog.alert(message, {
                    html: true,
                    animation: 'bounce',
                    backdropClose: false,
                    okText: 'OK',
                    // reverse: true,
                    loader: true,
                    centered: true
                })
                .then((dialog) => {
                    resolve(dialog);
                    dialog.close();
                })
                .catch(() => {
                    resolve(false);
                });
            })
        },

        //Funtion to check Hyperverge Validations
        checkHyperVergeValidation(shipData){
            return new Promise(async (resolve, reject) => {
                this.hvValidationFailedData = [];
                for (let i = 0; i < shipData.length; i++) {
                    const currShip = shipData[i];
                    if(!currShip.srItemObj.ishvonboardingdone || !currShip.srItemObj.isselfieverified){
                        let isAlreadyPresent = this.hvValidationFailedData.some(
                            (item) => item.deliveryUserId === currShip.DeliveryUserId
                        );
                        if (!isAlreadyPresent) {
                            let hvFailureMsg = !currShip.srItemObj.ishvonboardingdone ? this.hvOnboardingFailMsg : this.hvSelieFailMsg;
                            let hvFailShipObj = {
                                deliveryUserId: currShip.DeliveryUserId,
                                userName: currShip.DeliveryUserName,
                                hyperVFailureMsg: hvFailureMsg
                            }
                            this.hvValidationFailedData.push(hvFailShipObj);
                        }
                    }
                }

                // Remove shipment from shipData if DeliveryUserId presents in hvValidationFailedData
                let filteredShipData = shipData.filter(ship => 
                    !this.hvValidationFailedData.some(failedShip => failedShip.deliveryUserId === ship.DeliveryUserId)
                );
                return resolve(filteredShipData);
            })
        },
        
        showHVValidationDialog(){
            return new Promise((resolve) => {
                const tableRows = this.hvValidationFailedData.map((user) => `
                    <tr>
                        <td style="padding: 8px; border-bottom: 1px solid #ddd;border-right: 1px solid #ddd; border-left: 1px solid #ddd">${user.userName}</td>
                        <td style="padding: 8px; border-bottom: 1px solid #ddd;border-right: 1px solid #ddd; border-left: 1px solid #ddd">${user.hyperVFailureMsg}</td>
                    </tr>`
                ).join('');
                
                const message = `
                    <div style="max-height: 300px; width: auto; overflow-y: auto; overflow-x: auto; padding: 10px;">
                        <p style="width: auto; font-size: 16px; font-weight: bold; margin-bottom: 10px; color: red">
                            Allocation is blocked for below users:
                        </p>
                        <table style="width: auto; border-collapse: collapse; text-align: left;">
                            <thead>
                            <tr>
                                <th style="border-bottom: 1px solid #ddd; padding: 8px;border-right: 1px solid #ddd; border-left: 1px solid #ddd;border-top: 1px solid #ddd">Username</th>
                                <th style="border-bottom: 1px solid #ddd; padding: 8px;border-right: 1px solid #ddd; border-left: 1px solid #ddd;border-top: 1px solid #ddd">Failure Reason</th>
                            </tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                    </div>
                `;
                
                this.$dialog.alert(message, {
                    html: true,
                    animation: 'bounce',
                    backdropClose: false,
                    okText: 'OK',
                    // reverse: true,
                    loader: true,
                    centered: true,
                })
                .then((dialog) => {
                    resolve(dialog);
                    dialog.close();
                })
                .catch(() => {
                    resolve(false);
                });
            })
        },

        async processBatchWiseAllocation(batchSize = 20, UASelectedArr, maxRetries = 3) {

            let results = [];

            // Wrap items with retry counter
            let queue = UASelectedArr.map(item => ({ item, attempts: 0 }));

            while (queue.length > 0) {

                // Take the next batch from the front of the queue
                const batch = queue.splice(0, batchSize);

                // Run allocation
                let batchResults = await Promise.allSettled(
                    batch.map(val => this.bulkAllocationForRVP2(val.item))
                );

                batchResults.forEach((res, idx) => {
                    const current = batch[idx];

                    if (res.status === "fulfilled" && (!res.value || res.value.statusCode !== 110)) {
                        // ✅ Success
                        results.push(res);
                    } else {
                        // ❌ Retry
                        if (current.attempts + 1 < maxRetries) {
                            console.log(
                                `Retrying shipment (attempt ${current.attempts + 1}/${maxRetries})`
                            );
                            // Push failed item back into the end of the queue
                            queue.push({ item: current.item, attempts: current.attempts + 1 });
                        } else {
                            console.log(`Shipment failed after ${maxRetries} attempts, giving up`);
                            results.push(res); // Final failure
                        }
                    }
                });
            }
            return results;
        },

        /* Updated Code here */
        updateDynamicType(type, finalResult) {
            let list = finalResult[type].list;
            let upper = type.toUpperCase();

            // Always initialize master list
            if (!this[`set${upper}ListAll`]) this.$set(this, `set${upper}ListAll`, []);

            if (list) {
                let keys = Object.keys(list);

                // Ensure priorities exist

                this[`${type}Priorities`] = [
                'All',
                ...new Set(
                    keys
                    .filter(p => p)
                    .sort((a, b) => {
                        // sort priorities like P0, P1, P2 numerically
                        let numA = parseInt(a.replace(/\D/g, '')) || 0;
                        let numB = parseInt(b.replace(/\D/g, '')) || 0;
                        return numA - numB;
                    })
                )
                ];

                // ✅ Reset all arrays & counts for this type before reassigning
                this[`set${upper}ListAll`] = [];
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    // Initialize reactivity if missing
                    if (!(listProp in this)) this.$set(this, listProp, []);
                    if (!(countProp in this)) this.$set(this, countProp, 0);
                    if (!(flagProp in this)) this.$set(this, flagProp, false);

                    // ✅ Reset existing data before filling
                    this[listProp] = [];
                    this[countProp] = 0;
                    this[flagProp] = false;
                });

                // Fill the lists dynamically
                keys.forEach(priority => {
                    let listProp = `set${upper}List${priority}`;
                    let countProp = `set${upper}Count${priority}`;
                    let flagProp = `set${upper}Count${priority}Flag`;

                    let items = Array.isArray(list[priority]) ? list[priority] : [];

                    this[countProp] = items.length;
                    this[flagProp] = items.length > 0;

                    if (items.length) {
                        this[listProp] = [...items];
                        this[`set${upper}ListAll`] = [...this[`set${upper}ListAll`], ...items];
                    }
                });

                // Calculate total counts
                let total = keys.reduce((acc, k) => acc + (Number(this[`set${upper}Count${k}`]) || 0), 0);

                if (!(`set${upper}CountAll` in this)) this.$set(this, `set${upper}CountAll`, 0);
                if (!(`set${upper}CountAllFlag` in this)) this.$set(this, `set${upper}CountAllFlag`, false);

                this[`set${upper}CountAll`] = total;
                this[`set${upper}CountAllFlag`] = total > 0;
            }
        },

        /** Return dynamic count */
        getCount(type, priority) {
            let key = `set${type.toUpperCase()}Count${priority}`;
            return this[key] || 0;
        },

        /** Return visibility flag */
        getFlagVisibility(type, priority) {
            let key = `set${type.toUpperCase()}Count${priority}Flag`;
            return this[key] || false;
        },

        /** Return active variant */
        getActiveVariant(type, priority) {
            let key = `activeTab${type.toUpperCase()}${priority}Flag`;
            return this[key] || 'outline-primary';
        },
    },
};


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/Reverseallocationv2/Reverseallocationv2.js